/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  JSON: {
    input:
      | Record<string, unknown>
      | unknown[]
      | string
      | number
      | boolean
      | null;
    output:
      | Record<string, unknown>
      | unknown[]
      | string
      | number
      | boolean
      | null;
  };
};

/** Error when a user has an active payment method */
export type ActivePaymentMethodError = UserError & {
  readonly __typename?: 'ActivePaymentMethodError';
  readonly errorMessage: Scalars['String']['output'];
};

export type AddAddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type AddAddressResponseUnion =
  | AddAddressSuccess
  | InvalidAddress
  | ValidationError;

export type AddAddressSuccess = {
  readonly __typename?: 'AddAddressSuccess';
  readonly address: Address;
};

export type AddAddressV2Input = {
  readonly city: Scalars['String']['input'];
  /** 2 letter country code */
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter state code */
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type AddLineItemBatchToCartInput = {
  readonly lineItems: ReadonlyArray<CartInput>;
};

export type AddLineItemToCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: InputMaybe<Scalars['Int']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type AddLineItemToCartResponseUnion =
  | AddLineItemToCartSuccess
  | LineItemModificationsInvalidException
  | LocationClosed
  | MaxModificationsExceeded
  | ProductOutOfStock
  | RestaurantHoursMissing
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type AddLineItemToCartSuccess = {
  readonly __typename?: 'AddLineItemToCartSuccess';
  readonly cart: Order;
};

export type AddLineItemToCartWithLoyaltyInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: InputMaybe<Scalars['Int']['input']>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type Addons = {
  readonly __typename?: 'Addons';
  readonly products: ReadonlyArray<Product>;
};

export type Address = {
  readonly __typename?: 'Address';
  readonly city: Scalars['String']['output'];
  /** 2 letter country code  */
  readonly country: Scalars['String']['output'];
  readonly deliveryPreference: DeliveryPreferenceType;
  /** @deprecated Migrating off google. Use lat/lng */
  readonly googlePlaceId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly notes: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  readonly secondaryStreet: Maybe<Scalars['String']['output']>;
  /** 2 letter state code  */
  readonly state: Scalars['String']['output'];
  /** Address Line 1 */
  readonly street: Scalars['String']['output'];
  readonly zipCode: Scalars['String']['output'];
};

export type AnonymizeCustomerInput = {
  readonly authToken: Scalars['String']['input'];
  readonly email: Scalars['String']['input'];
};

export type ApplyRewardByLoyaltyIdInput = {
  /** The loyalty ID of the customer. */
  readonly loyaltyId: Scalars['ID']['input'];
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export enum ApplyRewardFailureCode {
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  RestaurantNotAcceptingOrders = 'RESTAURANT_NOT_ACCEPTING_ORDERS',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
  RewardNotFound = 'REWARD_NOT_FOUND',
}

/** Validate and preview rewards success response */
export type ApplyRewardFailureMetadata = {
  readonly __typename?: 'ApplyRewardFailureMetadata';
  readonly requiredChannel: Maybe<Scalars['String']['output']>;
  readonly requiredDays: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
};

export type ApplyRewardInput = {
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export type ApplyRewardResponseUnion =
  | ApplyRewardSuccess
  | RewardNotApplied
  | ValidationError;

export type ApplyRewardSuccess = {
  readonly __typename?: 'ApplyRewardSuccess';
  readonly order: Order;
};

export type ApplyRewardWithLoyaltyInput = {
  /** The customer token of the customer. */
  readonly customerToken: Scalars['String']['input'];
  /** The ID of the order the reward is being applied to */
  readonly orderId: Scalars['ID']['input'];
  /** The ID of the reward being applied to the order */
  readonly rewardId: Scalars['ID']['input'];
};

export type Asset = {
  readonly __typename?: 'Asset';
  readonly url: Scalars['String']['output'];
};

/** Async cancelation failed */
export type AsyncCancelFailed = UserError & {
  readonly __typename?: 'AsyncCancelFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** The error response for available customer support points. */
export type AvailableCustomerSupportPointsError = UserError & {
  readonly __typename?: 'AvailableCustomerSupportPointsError';
  /** The error message. */
  readonly errorMessage: Scalars['String']['output'];
};

export type AvailableCustomerSupportPointsResponseUnion =
  | AvailableCustomerSupportPointsError
  | AvailableCustomerSupportPointsSuccess;

/** The response for available customer support points. */
export type AvailableCustomerSupportPointsSuccess = {
  readonly __typename?: 'AvailableCustomerSupportPointsSuccess';
  /** The available customer support points. */
  readonly points: ReadonlyArray<CustomerSupportPoint>;
};

export type AvailableWantedTime = {
  readonly __typename?: 'AvailableWantedTime';
  readonly deliveryOffset: Scalars['Int']['output'];
  readonly time: Scalars['String']['output'];
};

export type BaseProduct = {
  readonly __typename?: 'BaseProduct';
  readonly asset: Asset;
  readonly calories: Maybe<Scalars['Float']['output']>;
  readonly caloriesFromFat: Maybe<Scalars['Float']['output']>;
  readonly cholesterolMg: Maybe<Scalars['Float']['output']>;
  readonly contains: Maybe<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly dietaryFiberG: Maybe<Scalars['Float']['output']>;
  readonly heading: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isDeepLinkingEnabled: Scalars['Boolean']['output'];
  readonly isSeasonal: Scalars['Boolean']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly proteinG: Maybe<Scalars['Float']['output']>;
  readonly saturatedFatG: Maybe<Scalars['Float']['output']>;
  readonly slug: Scalars['String']['output'];
  readonly sodiumMg: Maybe<Scalars['Float']['output']>;
  readonly subheading: Scalars['String']['output'];
  readonly sugarsG: Maybe<Scalars['Float']['output']>;
  readonly totalCarbsG: Maybe<Scalars['Float']['output']>;
  readonly totalFatG: Maybe<Scalars['Float']['output']>;
  readonly transFatG: Maybe<Scalars['Float']['output']>;
};

export type BillingAccount = {
  readonly __typename?: 'BillingAccount';
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Scalars['String']['output'];
  readonly expirationState: ExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export enum BraintreeCardType {
  AmEx = 'AmEx',
  CarteBlanche = 'CarteBlanche',
  ChinaUnionPay = 'ChinaUnionPay',
  DinersClubInternational = 'DinersClubInternational',
  Discover = 'Discover',
  Elo = 'Elo',
  Jcb = 'JCB',
  Laser = 'Laser',
  Maestro = 'Maestro',
  MasterCard = 'MasterCard',
  Solo = 'Solo',
  Switch = 'Switch',
  UkMaestro = 'UKMaestro',
  Unknown = 'Unknown',
  Visa = 'Visa',
}

/** CX Credit */
export type CxCredit = {
  readonly __typename?: 'CXCredit';
  /** Display name of offer */
  readonly displayName: Scalars['String']['output'];
  /** ID of offer from loyalty vendor */
  readonly id: Scalars['ID']['output'];
};

/** Version of calories calculation method */
export enum CaloriesVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export type CanCancel = {
  readonly __typename?: 'CanCancel';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  /** Order ID validating on */
  readonly orderId: Scalars['ID']['output'];
  /**
   * Time in minutes before the order can no longer be canceled (sent to store)
   * @deprecated no longer supported.
   */
  readonly timeToFire: Scalars['Float']['output'];
};

/** Cannot find order to check if cancelation is allowed */
export type CanCancelAlreadySent = UserError & {
  readonly __typename?: 'CanCancelAlreadySent';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Generic Error for a failed can cancel query */
export type CanCancelFailed = UserError & {
  readonly __typename?: 'CanCancelFailed';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanCancelInput = {
  /** Gravy customer ID parent to the order being canceled. */
  readonly customerId: Scalars['String']['input'];
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Gravy restaurant ID parent to the order being canceled. */
  readonly restaurantId: Scalars['String']['input'];
  /** Watned time of order in ISO format. */
  readonly wantedTime: Scalars['DateTime']['input'];
};

/** Cannot find order to check if cancelation is allowed */
export type CanCancelNotFound = UserError & {
  readonly __typename?: 'CanCancelNotFound';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanCancelResponseUnion =
  | CanCancel
  | CanCancelAlreadySent
  | CanCancelFailed
  | CanCancelNotFound
  | CanCancelUnauthorized
  | CantCancelAlreadyCanceled
  | CantCancelLimitExcceeded
  | CantCancelOldOrders;

/** Unauthorized */
export type CanCancelUnauthorized = UserError & {
  readonly __typename?: 'CanCancelUnauthorized';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export type CanNotReorder = {
  readonly __typename?: 'CanNotReorder';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type CancelExternalOrderInput = {
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
};

export type CancelOrderExternalResponseUnion =
  | AsyncCancelFailed
  | CancelOrderFailed
  | CancelOrderSuccess
  | CancelOrderSuccessAsync
  | CancelSuccessRefundFailed
  | CancellationFailedWithDelivery
  | OrderAlreadyCanceled
  | OrderAlreadySentToKitchen
  | OrderNotFound;

/** Generic Error for a failed cancellation */
export type CancelOrderFailed = UserError & {
  readonly __typename?: 'CancelOrderFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderInput = {
  /** Gravy customer ID parent to the order being canceled. */
  readonly customerId: Scalars['String']['input'];
  /** Gravy order ID to be canceled. */
  readonly orderId: Scalars['ID']['input'];
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Description for why the order is being canceled. */
  readonly reason: Scalars['String']['input'];
  /** Refund the order if cancel succeeds?. */
  readonly refund: Scalars['Boolean']['input'];
  /** Gravy restaurant ID parent to the order being canceled. */
  readonly restaurantId: Scalars['String']['input'];
};

export type CancelOrderPaymentIntentInput = {
  readonly paymentIntentId: Scalars['String']['input'];
};

export type CancelOrderPaymentIntentResponse = {
  readonly __typename?: 'CancelOrderPaymentIntentResponse';
  readonly paymentIntentId: Scalars['ID']['output'];
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderResponseUnion =
  | AsyncCancelFailed
  | CancelOrderFailed
  | CancelOrderSuccess
  | CancelOrderSuccessAsync
  | CancelSuccessRefundFailed
  | CancellationFailedWithDelivery
  | CancellationLimitExceeded
  | OrderAlreadyCanceled
  | OrderAlreadySentToKitchen
  | OrderNotFound;

export type CancelOrderSuccess = {
  readonly __typename?: 'CancelOrderSuccess';
  readonly orderId: Scalars['ID']['output'];
  /** Reason for a failed order or a success string. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type CancelOrderSuccessAsync = {
  readonly __typename?: 'CancelOrderSuccessAsync';
  readonly orderId: Scalars['ID']['output'];
  /** Async order successfully canceled. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the async order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cancel succeeded but refund failed. */
export type CancelSuccessRefundFailed = UserError & {
  readonly __typename?: 'CancelSuccessRefundFailed';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cancellation failed with delivery service */
export type CancellationFailedWithDelivery = UserError & {
  readonly __typename?: 'CancellationFailedWithDelivery';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Cannot cancel more then one order per user per day */
export type CancellationLimitExceeded = UserError & {
  readonly __typename?: 'CancellationLimitExceeded';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Order has already been canceled */
export type CantCancelAlreadyCanceled = UserError & {
  readonly __typename?: 'CantCancelAlreadyCanceled';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Cannot cancel more then one order per user per day */
export type CantCancelLimitExcceeded = UserError & {
  readonly __typename?: 'CantCancelLimitExcceeded';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

/** Order is greater then 2 days old */
export type CantCancelOldOrders = UserError & {
  readonly __typename?: 'CantCancelOldOrders';
  /** Boolean representing if the order can be canceled or not. */
  readonly canCancel: Scalars['Boolean']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
};

export enum CardExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export enum CardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Unsupported = 'UNSUPPORTED',
  Visa = 'VISA',
}

export type CartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type CateringCustomer = {
  readonly __typename?: 'CateringCustomer';
  /** Customer first name */
  readonly first: Scalars['String']['output'];
  /** Customer last name */
  readonly last: Scalars['String']['output'];
};

export type CateringIngredient = {
  readonly __typename?: 'CateringIngredient';
  /** Whether the ingredient is eighty-sixed (out of stock) */
  readonly eightySixed: Scalars['Boolean']['output'];
  /** Ingredient ID */
  readonly id: Scalars['Int']['output'];
  /** Ingredient name */
  readonly name: Scalars['String']['output'];
};

export type CateringLineItem = {
  readonly __typename?: 'CateringLineItem';
  /** Whether the product is eighty-sixed (out of stock at this restaurant) */
  readonly eightySixed: Scalars['Boolean']['output'];
  /** List of ingredient additions */
  readonly ingredientAdditions: ReadonlyArray<CateringIngredient>;
  /** List of ingredients included in this line item */
  readonly ingredients: ReadonlyArray<CateringIngredient>;
  /** Product ID */
  readonly productId: Scalars['Int']['output'];
  /** Product name */
  readonly productName: Scalars['String']['output'];
  /** Quantity of this line item */
  readonly quantity: Scalars['Int']['output'];
  /** Special instructions for this line item */
  readonly specialInstructions: Maybe<Scalars['String']['output']>;
  /** Type of the item (e.g., SALAD, PLATE, WARM_BOWL, SIDES_AND_BEVERAGES, CATERING_BUNDLES) */
  readonly type: CateringProductType;
};

export type CateringOrder = {
  readonly __typename?: 'CateringOrder';
  /** Client (organization) name */
  readonly clientName: Maybe<Scalars['String']['output']>;
  /** Client phone number */
  readonly clientPhone: Maybe<Scalars['String']['output']>;
  /** Customer information */
  readonly customer: CateringCustomer;
  /** Delivery address line 1 */
  readonly deliveryAddress1: Maybe<Scalars['String']['output']>;
  /** Delivery address line 2 */
  readonly deliveryAddress2: Maybe<Scalars['String']['output']>;
  /** Delivery city */
  readonly deliveryCity: Maybe<Scalars['String']['output']>;
  /** Delivery postal code */
  readonly deliveryPostal: Maybe<Scalars['String']['output']>;
  /** Delivery state */
  readonly deliveryState: Maybe<Scalars['String']['output']>;
  /** External reference ID (monkey order ID) */
  readonly externalReferenceId: Scalars['Int']['output'];
  /** Whether the order has been submitted */
  readonly isSubmitted: Scalars['Boolean']['output'];
  /** Line items in the order */
  readonly lineItems: ReadonlyArray<CateringLineItem>;
  /** Number of guests */
  readonly numberOfGuests: Maybe<Scalars['Int']['output']>;
  /** Company name of the order acceptor */
  readonly orderAcceptorCompany: Scalars['String']['output'];
  /** Phone number of the order acceptor */
  readonly orderAcceptorPhone: Maybe<Scalars['String']['output']>;
  /** Restaurant ID (Gravy restaurant ID) */
  readonly restaurantID: Scalars['Int']['output'];
  /** Special instructions for the order */
  readonly specialInstructions: Maybe<Scalars['String']['output']>;
  /** Submission window close time (ISO string with timezone, same as wantedTimeAtStore) */
  readonly submissionWindowCloseAt: Scalars['String']['output'];
  /** Submission window open time (ISO string with timezone, calculated as wantedTimeAtStore - 14 hours) */
  readonly submissionWindowOpenAt: Scalars['String']['output'];
  /** Raw time_requested from Monkey DB in HHMM integer format (e.g., 1745 = 17:45) */
  readonly timeReqd: Scalars['Int']['output'];
  /** Wanted time at store (ISO string with timezone, e.g., "2025-12-12T17:00:00-07:00") */
  readonly wantedTimeAtStore: Scalars['String']['output'];
};

export type CateringOrdersInput = {
  /** Optional date in YYYY-MM-DD format. Defaults to today in restaurant timezone if not provided. */
  readonly date?: InputMaybe<Scalars['String']['input']>;
  /** The restaurant ID (Gravy restaurant ID) to fetch catering orders for */
  readonly restaurantId: Scalars['Int']['input'];
};

export type CateringOrdersResponse = {
  readonly __typename?: 'CateringOrdersResponse';
  /** List of catering orders */
  readonly orders: ReadonlyArray<CateringOrder>;
};

/** Type of the catering product item */
export enum CateringProductType {
  CateringBundles = 'CATERING_BUNDLES',
  Plate = 'PLATE',
  Salad = 'SALAD',
  SaladBar = 'SALAD_BAR',
  SidesAndBeverages = 'SIDES_AND_BEVERAGES',
  Unknown = 'UNKNOWN',
  WarmBowl = 'WARM_BOWL',
}

/** A Challenge is a configured SessionM Campaign with the "is_challenge: true" flag set in the campaign custom payload */
export type Challenge = {
  readonly __typename?: 'Challenge';
  /** Field is integer representation of the total amount of times the challenge behavior was completed by the customer. */
  readonly achieved: Scalars['Float']['output'];
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  /** Field originates from SessionM Activity feed configuration message description. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Field originates from SessionM Activity feed configuration message subheader. */
  readonly descriptiveTitle: Scalars['String']['output'];
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field is a number representation of the challenge goal. Ex. A two STEP challenge would have a goal of `2.` A SPEND $20 challenge would have a goal of `2000` */
  readonly goal: Scalars['Float']['output'];
  /** Field is the SessionM campaign id */
  readonly id: Scalars['ID']['output'];
  readonly legalTerms: Scalars['String']['output'];
  /** Holds additional details (if needed) depending on the type of challenge (hurdle). */
  readonly multipleBehaviorDetails: Maybe<MultipleBehaviorDetailsUnion>;
  /** Field is `progress` divided by `goal` times 100. To be used to render progress bar. */
  readonly percentageCompleted: Scalars['Float']['output'];
  readonly permalink: Scalars['String']['output'];
  /** Field indicates the current count completed toward challenge goal. */
  readonly progress: Scalars['Float']['output'];
  /** Field is copy to show on the challenge card to indicate progress. Determined by challenge status and progress fields. */
  readonly progressCopy: Scalars['String']['output'];
  /** Field is the progress type of the challenge */
  readonly progressType: ChallengeProgressType;
  readonly status: ChallengeStatus;
  /**
   * Field represents the type of challenge, e.g. FLASH. Defaults to DEFAULT
   * @deprecated Deprecated in favor of "themeV2" field
   */
  readonly theme: ChallengeTheme;
  /** Field represents the type of challenge, e.g. FLASH. Defaults to DEFAULT */
  readonly themeV2: ChallengeThemeV2;
  /** Field originates from SessionM Activity feed configuration message header. */
  readonly title: Scalars['String']['output'];
};

/** Challenge celebration data originating from campaign information on SessionM. To be used to render challenge celebration messaging. */
export type ChallengeCelebration = {
  readonly __typename?: 'ChallengeCelebration';
  /** Field originates from SessionM Activity feed configuration message description. When a user has multiple rewards to be "celebrated" this field is hardcoded. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Completed challenges ids */
  readonly challengesIds: ReadonlyArray<Scalars['String']['output']>;
  /** Expiration date for reward. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field is hardcoded in challenges-svc */
  readonly rewardUsageDisclaimer: Scalars['String']['output'];
  /** Field originates from SessionM Activity Feed configuration message header. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly title: Maybe<Scalars['String']['output']>;
};

/** Challenge celebration data originating from campaign information on SessionM. To be used to render challenge celebration messaging. */
export type ChallengeCelebrationV2 = {
  readonly __typename?: 'ChallengeCelebrationV2';
  /** Field originates from SessionM Activity feed configuration message description. When a user has multiple rewards to be "celebrated" this field is hardcoded. */
  readonly celebrationCopy: Scalars['String']['output'];
  /** Completed challenges ids */
  readonly challengesIds: ReadonlyArray<Scalars['String']['output']>;
  /** Expiration date for reward. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  /** Field originates from SessionM Activity Feed configuration message header. When a user has multiple rewards available to be "celebrated" this field will return null. */
  readonly title: Scalars['String']['output'];
};

export type ChallengeOptInResultUnion = Challenge | LoyaltyOptInFailed;

/** Step = step challenge, Spend = spend challenge */
export enum ChallengeProgressType {
  Spend = 'Spend',
  Step = 'Step',
}

/** Reward available to the customer */
export type ChallengeReward = {
  readonly __typename?: 'ChallengeReward';
  readonly expiresAt: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  /** The Premium reward is only available to a customer 1x every twelve hours. The redeemable field allows the UI to indicate whether the reward is currently available to be used. */
  readonly redeemable: Maybe<Scalars['Boolean']['output']>;
  /** The Premium reward is only available to a customer 1x every twelve hours. The redeemableAt will populate if reward is not redeemable with the next available date. */
  readonly redeemableAt: Maybe<Scalars['DateTime']['output']>;
  /** The channel(s) in which the reward can be redeemed */
  readonly redemptionChannel: RedemptionChannel;
  /** Type PREMIUM refers to Premium Subscription Reward, NON_PREMIUM rewards not associated with loyalty program */
  readonly rewardType: RewardType;
  /** Field references the offer terms and conditions configured in SessionM. If that field is not configured, returns the default SG terms url. */
  readonly terms: Scalars['String']['output'];
};

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export enum ChallengeStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
}

export enum ChallengeTheme {
  Default = 'DEFAULT',
  Flash = 'FLASH',
}

export enum ChallengeThemeV2 {
  Default = 'DEFAULT',
  Flash = 'FLASH',
  Hurdle = 'HURDLE',
  Unlimited = 'UNLIMITED',
}

export type ChangeDetail = {
  readonly __typename?: 'ChangeDetail';
  /** The field path that changed */
  readonly field: Scalars['String']['output'];
  /** The new value (null if removed) */
  readonly newValue: Maybe<Scalars['JSON']['output']>;
  /** The previous value (null if not present) */
  readonly oldValue: Maybe<Scalars['JSON']['output']>;
};

/** JWT token used to login a user in a chat app. */
export type ChatToken = {
  readonly __typename?: 'ChatToken';
  readonly token: Scalars['String']['output'];
};

export type ChildSyncResult = {
  readonly __typename?: 'ChildSyncResult';
  /** Error message if sync failed */
  readonly error: Maybe<Scalars['String']['output']>;
  /** The Salesforce ID of the child outpost */
  readonly salesforceId: Scalars['String']['output'];
  /** Whether the child sync succeeded */
  readonly success: Scalars['Boolean']['output'];
};

export type ClosedLoyaltyTransactionDetailsInput = {
  readonly createdAt: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly isInFlight: Scalars['Boolean']['input'];
  readonly isInFlightDelivery: Scalars['Boolean']['input'];
  readonly lineItems: ReadonlyArray<OrderLineItemInput>;
  readonly orderType: Scalars['String']['input'];
  readonly payments: ReadonlyArray<OrderPaymentInput>;
  readonly restaurantEntityId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantParentId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantUtcOffset?: InputMaybe<Scalars['Float']['input']>;
  readonly selectedRewards?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']>
  >;
  /** The selected reward with root offer id */
  readonly selectedRewardsWithDetails?: InputMaybe<
    ReadonlyArray<SelectedRewardsWithDetails>
  >;
  readonly subtotal: Scalars['Float']['input'];
  readonly tax: Scalars['Float']['input'];
  readonly updatedAt?: InputMaybe<Scalars['String']['input']>;
  readonly wantedTime?: InputMaybe<Scalars['String']['input']>;
};

export enum ConflictType {
  DeliveryIneligible = 'DELIVERY_INELIGIBLE',
  IngredientUnavailable = 'INGREDIENT_UNAVAILABLE',
  NoConflict = 'NO_CONFLICT',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',
}

/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export enum CostChannel {
  DefaultCostChannel = 'DEFAULT_COST_CHANNEL',
  DeliveryCostChannel = 'DELIVERY_COST_CHANNEL',
  PickupCostChannel = 'PICKUP_COST_CHANNEL',
}

export type CourierDetails = {
  readonly __typename?: 'CourierDetails';
  readonly latitude: Maybe<Scalars['Float']['output']>;
  readonly longitude: Maybe<Scalars['Float']['output']>;
  readonly name: Maybe<Scalars['String']['output']>;
  readonly phone: Maybe<Scalars['String']['output']>;
};

export type CreateAccountInput = {
  /** Must be in YYYY-MM-DD format. */
  readonly birthday?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  /** Must be a valid US phone number, exactly 10 digits with no formatting. */
  readonly phoneNumber: Scalars['String']['input'];
  /** Required for personalization use cases. */
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountResponseUnion = CreateAccountSuccess | ValidationError;

export type CreateAccountSuccess = {
  readonly __typename?: 'CreateAccountSuccess';
  readonly customer: Customer;
};

export type CreateAndSubmitOrderInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** If the client has their own identifier for this order, they should provide it here for potential correlation on sweetgreen's end. For example, delivery marketplaces should provide their order id. */
  readonly externalReferenceId?: InputMaybe<Scalars['ID']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly lineItems?: InputMaybe<ReadonlyArray<CartInput>>;
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  /** The restaurant ID for this order */
  readonly restaurantId: Scalars['Int']['input'];
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

/** Successful connection token response */
export type CreateConnectionTokenResponse = {
  readonly __typename?: 'CreateConnectionTokenResponse';
  /** A token to pass token to the Stripe Terminal SDK */
  readonly secret: Scalars['String']['output'];
};

/** Successful location creation response */
export type CreateKioskReaderLocationIdResponse = {
  readonly __typename?: 'CreateKioskReaderLocationIdResponse';
  readonly id: Scalars['String']['output'];
};

export type CreateLoyaltyProfileError = UserError & {
  readonly __typename?: 'CreateLoyaltyProfileError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CreateLoyaltyProfileResponseUnion =
  | CreateLoyaltyProfileError
  | CreateLoyaltyProfileSuccess;

export type CreateLoyaltyProfileSuccess = {
  readonly __typename?: 'CreateLoyaltyProfileSuccess';
  readonly loyaltyProfile: LoyaltyProfile;
};

export type CreateOrderPaymentIntentInput = {
  readonly amount: Scalars['Float']['input'];
  readonly deliveryOrderDetail?: InputMaybe<PaymentIntentDeliveryOrderDetail>;
  readonly dropoffLocationId?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType: Scalars['String']['input'];
  readonly orderId: Scalars['String']['input'];
  readonly orderType: Scalars['String']['input'];
  readonly paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantEntityId: Scalars['String']['input'];
  readonly shouldSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly useCredit?: InputMaybe<Scalars['Boolean']['input']>;
  readonly wantedTime: Scalars['String']['input'];
};

export type CreateSetupIntent = {
  readonly __typename?: 'CreateSetupIntent';
  /** The Stripe created setup intent secret, required for the client to confirm its creation */
  readonly clientSecret: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type Credit = {
  readonly __typename?: 'Credit';
  readonly amount: Scalars['Float']['output'];
  readonly createdAt: Scalars['String']['output'];
  /** The type of credit */
  readonly creditType: CreditType;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expiresAt: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly remainingAmount: Scalars['Float']['output'];
  readonly storefrontEligibilityTitle: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export enum CreditType {
  AllNativeStorefronts = 'ALL_NATIVE_STOREFRONTS',
  InStoreOnly = 'IN_STORE_ONLY',
  OnlineOnly = 'ONLINE_ONLY',
}

export enum CustomProductType {
  Bowl = 'BOWL',
  Plate = 'PLATE',
}

/** Customer details including available credits */
export type Customer = {
  readonly __typename?: 'Customer';
  readonly addresses: ReadonlyArray<Address>;
  /** The amount of credit available to the customer. Credit is applied after tax. */
  readonly availableCredit: Scalars['Int']['output'];
  /** @deprecated Deprecated in favor of `paymentMethodCards` query. */
  readonly billingAccounts: ReadonlyArray<BillingAccount>;
  readonly birthday: Maybe<Scalars['String']['output']>;
  /** A detail list of available credits to the customer. */
  readonly credits: ReadonlyArray<Credit>;
  /**
   * Is this user marked for deletion.
   * @deprecated Clients have no use for this field.
   */
  readonly deletionInProgress: Maybe<Scalars['Boolean']['output']>;
  readonly email: Maybe<Scalars['String']['output']>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
  readonly phoneNumber: Maybe<Scalars['String']['output']>;
  /** Level Up / Paytronix Payment Token for the customer, used to generate QR codes. */
  readonly qrCode: Scalars['String']['output'];
  /** Level Up Share URL to be used when sharing by email. */
  readonly referralShareUrlEmail: Scalars['String']['output'];
  /** Gravy-generated UUID used for analytics purposes */
  readonly trackingUuid: Maybe<Scalars['String']['output']>;
  /** Whether or not the customer will use any available credit on their next transaction. */
  readonly useCredit: Scalars['Boolean']['output'];
  readonly zipCode: Maybe<Scalars['String']['output']>;
};

export type CustomerExistsInput = {
  readonly authToken: Scalars['String']['input'];
  readonly email: Scalars['String']['input'];
};

export type CustomerNotFound = UserError & {
  readonly __typename?: 'CustomerNotFound';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerPass = {
  readonly __typename?: 'CustomerPass';
  readonly authenticationToken: Maybe<Scalars['String']['output']>;
  readonly url: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInfo = {
  readonly __typename?: 'CustomerPaymentInfo';
  readonly id: Scalars['ID']['output'];
  /** Stripe ephemeral key used to configure the payment element on the client. */
  readonly paymentEphemeralKey: Scalars['String']['output'];
  /** Stripe customer session id used to configure the payment element on the client. */
  readonly paymentSessionId: Scalars['String']['output'];
};

export type CustomerPointsForCustomerSupportFailureError = UserError & {
  readonly __typename?: 'CustomerPointsForCustomerSupportFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerPointsForCustomerSupportResponseUnion =
  | CustomerPointsForCustomerSupportFailureError
  | CustomerPointsForCustomerSupportSuccessResponse;

/** Successful response for customer points for customer support. */
export type CustomerPointsForCustomerSupportSuccessResponse = {
  readonly __typename?: 'CustomerPointsForCustomerSupportSuccessResponse';
  readonly points: Scalars['Int']['output'];
};

/** Customer Preference */
export type CustomerPreference = {
  readonly __typename?: 'CustomerPreference';
  readonly dietaryRestrictions: ReadonlyArray<DietaryRestriction>;
  readonly hasSyncedRestrictions: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
};

export type CustomerPreferencesInput = {
  readonly dietaryRestrictions: ReadonlyArray<DietaryRestriction>;
};

/** Failure to fetch Customer Support Credits */
export type CustomerSupportCreditsFailureError = UserError & {
  readonly __typename?: 'CustomerSupportCreditsFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerSupportCreditsResponseUnion =
  | CustomerSupportCreditsFailureError
  | CustomerSupportCreditsSuccessResponse;

/** Customer Support Credits Result */
export type CustomerSupportCreditsSuccessResponse = {
  readonly __typename?: 'CustomerSupportCreditsSuccessResponse';
  /** Credits allocated for customer support team to issue to customers */
  readonly credits: ReadonlyArray<CxCredit>;
};

/** A customer support point. */
export type CustomerSupportPoint = {
  readonly __typename?: 'CustomerSupportPoint';
  /** The display value of the points available. */
  readonly displayValue: Scalars['String']['output'];
  /** The number of points available for customer support to issue. */
  readonly value: Scalars['Float']['output'];
};

export type CustomerTokenError = UserError & {
  readonly __typename?: 'CustomerTokenError';
  readonly code: Scalars['String']['output'];
  readonly errorMessage: Scalars['String']['output'];
};

export type CustomerTokenResponseUnion =
  | CustomerTokenError
  | LoyaltyAccessToken;

export type DeclinedPaymentMethod = UserError & {
  readonly __typename?: 'DeclinedPaymentMethod';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type DeleteAddressResponseUnion =
  | DeleteAddressSuccess
  | InvalidAddress
  | ValidationError;

export type DeleteAddressSuccess = {
  readonly __typename?: 'DeleteAddressSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type DeletePaymentMethodCardInput = {
  /** Id of card to delete */
  readonly id: Scalars['String']['input'];
};

export type DeleteSubscriptionPaymentMethodResponseUnion =
  | ActivePaymentMethodError
  | DeleteSubscriptionPaymentMethodSuccess
  | UnknownUserError;

/** The result of deleting a payment method from a subscription */
export type DeleteSubscriptionPaymentMethodSuccess = {
  readonly __typename?: 'DeleteSubscriptionPaymentMethodSuccess';
  /** Payment Methods */
  readonly creditCards: ReadonlyArray<SubscriptionCreditCard>;
};

export type DeliveryAlreadyInFlight = UserError & {
  readonly __typename?: 'DeliveryAlreadyInFlight';
  readonly errorMessage: Scalars['String']['output'];
};

export type DeliveryOrderDetail = {
  readonly __typename?: 'DeliveryOrderDetail';
  readonly address: Maybe<Address>;
  /** Delivery Fee in cents */
  readonly deliveryFee: Scalars['Float']['output'];
  /** Estimated delivery time for an delivery order, usually used as a range with +- 15mins offset. For outpost orders this is represented by the order "wantedTime". */
  readonly estimatedDeliveryTime: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Courier tip in cents */
  readonly tip: Scalars['Float']['output'];
  readonly vendor: Scalars['String']['output'];
  readonly vendorRestaurantId: Scalars['String']['output'];
};

export type DeliveryOrderDetailInput = {
  readonly addressId: Scalars['ID']['input'];
  readonly deliveryFee: Scalars['Float']['input'];
  readonly tip: Scalars['Float']['input'];
  readonly vendor: Scalars['String']['input'];
  readonly vendorRestaurantId: Scalars['String']['input'];
};

export enum DeliveryPreferenceType {
  Curbside = 'CURBSIDE',
  Door = 'DOOR',
  LeaveAtDoor = 'LEAVE_AT_DOOR',
}

export type DeliverySpecifyAddress = UserError & {
  readonly __typename?: 'DeliverySpecifyAddress';
  readonly errorMessage: Scalars['String']['output'];
};

export type DietaryProperty = {
  readonly __typename?: 'DietaryProperty';
  readonly id: Scalars['ID']['output'];
  readonly name: DietaryPropertyKind;
};

export enum DietaryPropertyKind {
  Dairy = 'DAIRY',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Meat = 'MEAT',
  Nuts = 'NUTS',
  Soy = 'SOY',
}

export enum DietaryRestriction {
  Dairy = 'DAIRY',
  Fish = 'FISH',
  Gluten = 'GLUTEN',
  Meat = 'MEAT',
  Nuts = 'NUTS',
  Soy = 'SOY',
}

/** Discount on payment plan */
export type Discount = {
  readonly __typename?: 'Discount';
  /** The quantity of the discount */
  readonly amount: Maybe<Scalars['String']['output']>;
  /** The description of the discount */
  readonly description: Maybe<Scalars['String']['output']>;
  /** Discount identifier */
  readonly id: Scalars['ID']['output'];
  /** The name of the discount */
  readonly name: Scalars['ID']['output'];
};

export enum DressingMode {
  Mixed = 'MIXED',
  NotDressable = 'NOT_DRESSABLE',
  OnTheSide = 'ON_THE_SIDE',
  Removed = 'REMOVED',
}

export enum DressingWeight {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
}

export type DropOffLocation = {
  readonly __typename?: 'DropOffLocation';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

/** Unit used for handling duration types. */
export enum DurationUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type EditAddressInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly googlePlaceId: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type EditAddressV2Input = {
  readonly city: Scalars['String']['input'];
  /** 2 letter country code */
  readonly country: Scalars['String']['input'];
  readonly deliveryPreference: DeliveryPreferenceType;
  readonly id: Scalars['ID']['input'];
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryStreet?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter state code */
  readonly state: Scalars['String']['input'];
  readonly street: Scalars['String']['input'];
  readonly zipCode: Scalars['String']['input'];
};

export type EditLineItemInCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type EditLineItemInCartResponseUnion =
  | EditLineItemInCartSuccess
  | LocationClosed
  | MaxModificationsExceeded
  | RestaurantHoursMissing
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type EditLineItemInCartSuccess = {
  readonly __typename?: 'EditLineItemInCartSuccess';
  readonly cart: Order;
};

export type EditLineItemInCartWithLoyaltyInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: Scalars['ID']['input'];
  readonly quantity: Scalars['Int']['input'];
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type EightySixIngredientInput = {
  readonly inStock: Scalars['Boolean']['input'];
  readonly ingredientId: Scalars['String']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId: Scalars['String']['input'];
};

export type EightySixProductInput = {
  readonly inStock: Scalars['Boolean']['input'];
  readonly productId: Scalars['String']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId: Scalars['String']['input'];
};

export type EightySixResponse = {
  readonly __typename?: 'EightySixResponse';
  readonly message: Scalars['String']['output'];
  readonly success: Scalars['Boolean']['output'];
};

export type EstimateRange = {
  readonly __typename?: 'EstimateRange';
  readonly end: Scalars['Int']['output'];
  readonly start: Scalars['Int']['output'];
};

export enum ExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export type ExpiredReceipt = UserError & {
  readonly __typename?: 'ExpiredReceipt';
  readonly errorMessage: Scalars['String']['output'];
};

export type FailedToFetchPaymentIntent = UserError & {
  readonly __typename?: 'FailedToFetchPaymentIntent';
  readonly errorMessage: Scalars['String']['output'];
};

export type FavoriteLineItemInput = {
  readonly favorited: Scalars['Boolean']['input'];
  readonly lineItemId: Scalars['ID']['input'];
  readonly productId: Scalars['ID']['input'];
};

export type FavoritedLineItemsInput = {
  readonly page: Scalars['Int']['input'];
};

export type FeedbackInput = {
  readonly id: Scalars['ID']['input'];
  readonly isFeedbackComplete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderType?: InputMaybe<FeedbackOrderType>;
  readonly questionId: Scalars['ID']['input'];
  readonly responseIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Order type used in FeedbackInput type */
export enum FeedbackOrderType {
  Delivery = 'Delivery',
  InStore = 'InStore',
  Pickup = 'Pickup',
}

export type FeedbackQuestion = {
  readonly __typename?: 'FeedbackQuestion';
  readonly id: Scalars['ID']['output'];
  readonly responses: Maybe<ReadonlyArray<FeedbackResponse>>;
  readonly slug: Maybe<Scalars['String']['output']>;
  readonly text: Maybe<Scalars['String']['output']>;
};

export type FeedbackResponse = {
  readonly __typename?: 'FeedbackResponse';
  readonly id: Scalars['ID']['output'];
  readonly text: Scalars['String']['output'];
};

export type FeedbackSuccess = {
  readonly __typename?: 'FeedbackSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type FieldValidationError = {
  readonly __typename?: 'FieldValidationError';
  readonly field: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
};

export enum FlattenedOrderStatuses {
  Completed = 'completed',
  Delivering = 'delivering',
  Failed = 'failed',
  Preparing = 'preparing',
  ReadyForCourier = 'readyForCourier',
  Received = 'received',
}

/** Forbidden error - insufficient permissions or scopes */
export type ForbiddenError = {
  readonly __typename?: 'ForbiddenError';
  readonly code: Scalars['String']['output'];
  readonly errorMessage: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

/** input argument for geo distance based location search querys */
export type GeoCoordinates = {
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
};

export type GetKioskPaymentsForCurrentDateInput = {
  readonly restaurantEntityId: Scalars['Float']['input'];
  readonly utcOffset: Scalars['Float']['input'];
};

/** Payments for current day */
export type GetKioskPaymentsForCurrentDateResponse = {
  readonly __typename?: 'GetKioskPaymentsForCurrentDateResponse';
  readonly id: Scalars['ID']['output'];
  readonly payments: ReadonlyArray<KioskPayment>;
};

/** Successful kiosk reader location fetch */
export type GetKioskReaderLocationIdResponse = {
  readonly __typename?: 'GetKioskReaderLocationIdResponse';
  readonly id: Scalars['String']['output'];
};

/** "Gift card associated with another account" user error */
export type GiftCardAssociatedWithAnotherAccountError = UserError & {
  readonly __typename?: 'GiftCardAssociatedWithAnotherAccountError';
  readonly errorMessage: Scalars['String']['output'];
};

/** The customer's gift card balance result */
export type GiftCardBalance = {
  readonly __typename?: 'GiftCardBalance';
  /** Customer's ID. NOTE: It can be useful for client-side caching. */
  readonly customerId: Scalars['String']['output'];
  /** Customer's gift card balance in cents */
  readonly giftCardBalance: Scalars['Float']['output'];
};

export type GiftCardBalanceResponseUnion =
  | GiftCardBalance
  | UnableToGetGiftCardBalanceError;

/** The gift card order's delivery details */
export type GiftCardDeliveryDetail = {
  readonly __typename?: 'GiftCardDeliveryDetail';
  readonly deliveryDateTime: Maybe<Scalars['DateTime']['output']>;
  readonly deliveryMethods: ReadonlyArray<Scalars['String']['output']>;
  readonly isAsap: Scalars['Boolean']['output'];
};

/** Gift card was not found */
export type GiftCardNotFoundError = UserError & {
  readonly __typename?: 'GiftCardNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Successful gift card order details */
export type GiftCardOrderDetail = {
  readonly __typename?: 'GiftCardOrderDetail';
  /** Delivery options for the gift card order. */
  readonly deliveryDetail: GiftCardDeliveryDetail;
  /** Gift card order ID. */
  readonly id: Scalars['String']['output'];
  /** Gift card order purchase time. */
  readonly purchasedAt: Scalars['DateTime']['output'];
  /** Purchased gift cards. */
  readonly userGiftCards: ReadonlyArray<UserGiftCard>;
};

export type GiftCardOrderDetailResponseUnion =
  | GiftCardOrderDetail
  | GiftCardOrderNotFoundError;

/** Gift card order was not found */
export type GiftCardOrderNotFoundError = UserError & {
  readonly __typename?: 'GiftCardOrderNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Successful gift card purchase history */
export type GiftCardPurchaseHistory = {
  readonly __typename?: 'GiftCardPurchaseHistory';
  /** Customer's ID. It can be useful for client-side caching. */
  readonly customerId: Scalars['String']['output'];
  /** A list of gift card orders for this user. */
  readonly giftCardOrders: ReadonlyArray<GiftCardOrderDetail>;
};

export type GiftCardRedemptionDetailResponseUnion =
  | GiftCardNotFoundError
  | GiftCardRedemptionDetailSuccess;

/** Successful gift card redemption details */
export type GiftCardRedemptionDetailSuccess = {
  readonly __typename?: 'GiftCardRedemptionDetailSuccess';
  /** Gift card asset id. */
  readonly assetId: Maybe<Scalars['String']['output']>;
  /** Gift card balance. */
  readonly balance: Scalars['Float']['output'];
  /** Gift card number. */
  readonly cardNumber: Scalars['String']['output'];
  /** Gift card reg code. */
  readonly cardRegCode: Scalars['String']['output'];
  /** Message for gift card recipient. */
  readonly recipientMessage: Maybe<Scalars['String']['output']>;
  /** Gift card recipient's name. */
  readonly recipientName: Scalars['String']['output'];
  /** Gift card redemption id. */
  readonly redeemId: Scalars['String']['output'];
  /** Gift card sender's name. */
  readonly senderName: Scalars['String']['output'];
};

export enum GravyStatusType {
  ArrivedAtDropoff = 'ARRIVED_AT_DROPOFF',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryFailed = 'DELIVERY_FAILED',
  KitchenCompleted = 'KITCHEN_COMPLETED',
  OrderCreated = 'ORDER_CREATED',
  OrderStatusFailed = 'ORDER_STATUS_FAILED',
  OrderStatusPreorderFailed = 'ORDER_STATUS_PREORDER_FAILED',
  OrderSubmitted = 'ORDER_SUBMITTED',
  SubmitFailed = 'SUBMIT_FAILED',
  Unknown = 'UNKNOWN',
}

export type Guest = {
  readonly __typename?: 'Guest';
  readonly email: Maybe<Scalars['String']['output']>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
};

/** Used to determine if the user has unseen challenges, meaning they haven't yet queried for the challenge. */
export type HasUnseenChallenges = {
  readonly __typename?: 'HasUnseenChallenges';
  readonly hasUnseenChallenges: Scalars['Boolean']['output'];
};

export type HurdleBehavior = {
  readonly __typename?: 'HurdleBehavior';
  readonly achieved: Scalars['Float']['output'];
  readonly goal: Scalars['Float']['output'];
  readonly outcome: Scalars['Int']['output'];
  readonly progress: Scalars['Float']['output'];
};

export type HurdleBehaviorDetails = {
  readonly __typename?: 'HurdleBehaviorDetails';
  readonly hurdleBehaviors: ReadonlyArray<HurdleBehavior>;
};

export type IdentifyAndClaimInStoreOrderInput = {
  /** ISO Format, e.g. 2024-01-15T10:30:00Z */
  readonly date: Scalars['String']['input'];
  /** POS if alphanumeric, Kiosk otherwise */
  readonly orderId: Scalars['ID']['input'];
  /** Only numbers, may begin with 0 */
  readonly restaurantZip: Scalars['String']['input'];
  /** Total in cents */
  readonly total: Scalars['Int']['input'];
};

export type IdentifyAndClaimInStoreOrderResponseUnion =
  | IdentifyAndClaimInStoreOrderSuccess
  | ReceiptAlreadyClaimedError
  | TimeRestrictionError
  | TransactionNotFoundError;

export type IdentifyAndClaimInStoreOrderSuccess = {
  readonly __typename?: 'IdentifyAndClaimInStoreOrderSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type InStoreOrder = {
  readonly __typename?: 'InStoreOrder';
  readonly id: Scalars['ID']['output'];
  readonly isPendingFeedback: Scalars['Boolean']['output'];
  readonly ledger: InStoreOrderLedger;
  readonly lineItems: ReadonlyArray<InStoreOrderLineItem>;
  readonly orderStatus: Scalars['String']['output'];
  readonly restaurant: InStoreOrderRestaurant;
  readonly vendorId: Scalars['String']['output'];
  readonly wantedTime: Scalars['String']['output'];
};

export type InStoreOrderDiscount = {
  readonly __typename?: 'InStoreOrderDiscount';
  readonly amount: Scalars['Float']['output'];
  readonly isLoyalty: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type InStoreOrderInput = {
  readonly id: Scalars['ID']['input'];
};

export type InStoreOrderLedger = {
  readonly __typename?: 'InStoreOrderLedger';
  readonly discounts: ReadonlyArray<InStoreOrderDiscount>;
  readonly payments: ReadonlyArray<InStoreOrderPayment>;
  readonly subtotal: Scalars['Float']['output'];
  readonly tax: Scalars['Float']['output'];
  readonly tip: Scalars['Float']['output'];
  readonly total: Scalars['Float']['output'];
};

export type InStoreOrderLineItem = {
  readonly __typename?: 'InStoreOrderLineItem';
  readonly asset: InStoreOrderLineItemAsset;
  readonly brinkId: Scalars['String']['output'];
  readonly isCustom: Scalars['Boolean']['output'];
  readonly isCustomProduct: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly price: Scalars['Float']['output'];
  readonly quantity: Scalars['Float']['output'];
};

export type InStoreOrderLineItemAsset = {
  readonly __typename?: 'InStoreOrderLineItemAsset';
  readonly url: Scalars['String']['output'];
};

export type InStoreOrderPayment = {
  readonly __typename?: 'InStoreOrderPayment';
  readonly amount: Scalars['Float']['output'];
  readonly type: Scalars['String']['output'];
};

export type InStoreOrderRestaurant = {
  readonly __typename?: 'InStoreOrderRestaurant';
  readonly address: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly entityId: Scalars['ID']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly name: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly zipCode: Scalars['String']['output'];
};

export type InStoreOrdersInput = {
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type InStoreOrdersResponse = {
  readonly __typename?: 'InStoreOrdersResponse';
  readonly inStoreOrders: ReadonlyArray<InStoreOrder>;
  readonly pagination: Pagination;
};

export type IncorrectPaymentMethod = UserError & {
  readonly __typename?: 'IncorrectPaymentMethod';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Ingredient = {
  readonly __typename?: 'Ingredient';
  readonly asset: Asset;
  readonly availableDate: Maybe<Scalars['DateTime']['output']>;
  readonly calories: Maybe<Scalars['Float']['output']>;
  readonly caloriesFromFat: Maybe<Scalars['Float']['output']>;
  readonly cholesterolMg: Maybe<Scalars['Float']['output']>;
  readonly co2eKg: Maybe<Scalars['Float']['output']>;
  readonly dietaryFiberG: Maybe<Scalars['Float']['output']>;
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  readonly expirationDate: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isGrain: Maybe<Scalars['Boolean']['output']>;
  readonly isMixable: Maybe<Scalars['Boolean']['output']>;
  readonly isWarmBase: Maybe<Scalars['Boolean']['output']>;
  readonly kind: Maybe<IngredientKind>;
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly proteinG: Maybe<Scalars['Float']['output']>;
  readonly saturatedFatG: Maybe<Scalars['Float']['output']>;
  readonly servingMeasure: Maybe<Scalars['Float']['output']>;
  readonly servingUnitOfMeasure: Maybe<Scalars['String']['output']>;
  readonly sodiumMg: Maybe<Scalars['Float']['output']>;
  readonly sugarsG: Maybe<Scalars['Float']['output']>;
  readonly totalCarbsG: Maybe<Scalars['Float']['output']>;
  readonly totalFatG: Maybe<Scalars['Float']['output']>;
  readonly transFatG: Maybe<Scalars['Float']['output']>;
};

export type IngredientAssetArgs = {
  version?: InputMaybe<IngredientAssetVersion>;
};

export type IngredientCaloriesArgs = {
  version?: InputMaybe<CaloriesVersion>;
};

/** Ingredient asset version */
export enum IngredientAssetVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export enum IngredientKind {
  Base = 'BASE',
  Dressing = 'DRESSING',
  Premium = 'PREMIUM',
  Topping = 'TOPPING',
}

export type IngredientModification = {
  readonly __typename?: 'IngredientModification';
  readonly additionCost: Scalars['Float']['output'];
  readonly calories: Scalars['Float']['output'];
  readonly ingredient: Ingredient;
  /** Asserts whether the ingredient modification is a "grain" type (like "rice," "quinoa," etc.) */
  readonly isGrain: Scalars['Boolean']['output'];
  readonly kind: Maybe<Scalars['String']['output']>;
  /** Is the modification able to be mixed-in to the salad, primarily used for dressings */
  readonly mixable: Scalars['Boolean']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  readonly removalCost: Scalars['Float']['output'];
  readonly subKind: Maybe<Scalars['String']['output']>;
  readonly substitutionCost: Scalars['Float']['output'];
};

export type IngredientModificationInput = {
  readonly ingredientId: Scalars['ID']['input'];
};

export type IngredientModificationKind = {
  readonly __typename?: 'IngredientModificationKind';
  /** The kind allows multiple quantity selections for a modification. */
  readonly allowMultipleQuantity: Scalars['Boolean']['output'];
  /** The number of free ingredient modifications that can be added of this kind. */
  readonly freeAggregateQuantity: Scalars['Int']['output'];
  /** The maximum number of ingredient modifications that can be of this kind. */
  readonly maxAggregateQuantity: Scalars['Int']['output'];
  /** The minimum number of ingredient modifications that can be of this kind. */
  readonly minAggregateQuantity: Scalars['Int']['output'];
  readonly modifications: ReadonlyArray<IngredientModification>;
};

export type IngredientModifications = {
  readonly __typename?: 'IngredientModifications';
  readonly bases: IngredientModificationKind;
  readonly bread: IngredientModificationKind;
  readonly dressings: IngredientModificationKind;
  readonly premiums: IngredientModificationKind;
  readonly toppings: IngredientModificationKind;
};

export type IngredientModifier = {
  readonly __typename?: 'IngredientModifier';
  readonly additionCost: Scalars['Float']['output'];
  readonly brinkPlu: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ingredient: Maybe<Ingredient>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Maybe<Scalars['Boolean']['output']>;
  readonly removalCost: Scalars['Float']['output'];
  readonly subKind: Maybe<Scalars['String']['output']>;
  readonly substitutionCost: Scalars['Float']['output'];
};

export type IngredientSubstitutionModificationInput = {
  readonly addedIngredientId: Scalars['ID']['input'];
  readonly removedIngredientId: Scalars['ID']['input'];
};

export type InvalidAddress = {
  readonly __typename?: 'InvalidAddress';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidBillingAccount = UserError & {
  readonly __typename?: 'InvalidBillingAccount';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidCreditCard = UserError & {
  readonly __typename?: 'InvalidCreditCard';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidCustomerPhone = UserError & {
  readonly __typename?: 'InvalidCustomerPhone';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Invalid gift card" user error */
export type InvalidGiftCardError = UserError & {
  readonly __typename?: 'InvalidGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

export type InvalidInput = {
  readonly __typename?: 'InvalidInput';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidOrder = UserError & {
  readonly __typename?: 'InvalidOrder';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidPromoCode = {
  readonly __typename?: 'InvalidPromoCode';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type InvalidRefundAmount = UserError & {
  readonly __typename?: 'InvalidRefundAmount';
  readonly errorMessage: Scalars['String']['output'];
};

export type InvalidTip = UserError & {
  readonly __typename?: 'InvalidTip';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type IssueCustomerSupportCreditResult = {
  readonly __typename?: 'IssueCustomerSupportCreditResult';
  readonly success: Scalars['Boolean']['output'];
};

export type IssueCustomerSupportPointsFailureError = UserError & {
  readonly __typename?: 'IssueCustomerSupportPointsFailureError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Response for issuing customer support points */
export type IssueCustomerSupportPointsResponse =
  | IssueCustomerSupportPointsFailureError
  | IssueCustomerSupportPointsSuccessResponse;

/** Success response for issuing customer support points */
export type IssueCustomerSupportPointsSuccessResponse = {
  readonly __typename?: 'IssueCustomerSupportPointsSuccessResponse';
  readonly credits: Scalars['Int']['output'];
};

export type KioskCustomerProfile = {
  readonly __typename?: 'KioskCustomerProfile';
  readonly firstName: Maybe<Scalars['String']['output']>;
  /** Gravy customer ID */
  readonly id: Scalars['ID']['output'];
  readonly lastName: Maybe<Scalars['String']['output']>;
  /** Vendor Loyalty ID of the current customer */
  readonly loyaltyId: Maybe<Scalars['String']['output']>;
};

export type KioskCustomerScanPaymentInfo = {
  readonly __typename?: 'KioskCustomerScanPaymentInfo';
  readonly cardBrand: Maybe<Scalars['String']['output']>;
  readonly cardLast4: Maybe<Scalars['String']['output']>;
  readonly creditBalance: Maybe<Scalars['Int']['output']>;
};

export type KioskCustomerScanPaymentInfoError = UserError & {
  readonly __typename?: 'KioskCustomerScanPaymentInfoError';
  readonly errorMessage: Scalars['String']['output'];
};

export type KioskCustomerScanPaymentInfoResponse =
  | KioskCustomerScanPaymentInfoError
  | KioskCustomerScanPaymentInfoSuccess;

export type KioskCustomerScanPaymentInfoSuccess = {
  readonly __typename?: 'KioskCustomerScanPaymentInfoSuccess';
  readonly payment: Maybe<KioskCustomerScanPaymentInfo>;
  readonly purpose: LoyaltyAccessTokenPurpose;
};

export type KioskPayment = {
  readonly __typename?: 'KioskPayment';
  readonly amount: Scalars['Int']['output'];
  readonly cardBrand: Maybe<Scalars['String']['output']>;
  readonly cardholderName: Maybe<Scalars['String']['output']>;
  readonly created: Scalars['String']['output'];
  /** payment id */
  readonly id: Scalars['ID']['output'];
  readonly last4: Maybe<Scalars['String']['output']>;
  readonly orderId: Scalars['String']['output'];
  readonly receiptUrl: Maybe<Scalars['String']['output']>;
  readonly refunded: Scalars['Boolean']['output'];
  readonly refundedAmount: Scalars['Int']['output'];
  readonly status: Scalars['String']['output'];
};

export type KioskRefundInput = {
  /** Full name of administrator who is refunding */
  readonly administratorName: Scalars['String']['input'];
  readonly amount: Scalars['Int']['input'];
  readonly orderId: Scalars['String']['input'];
  readonly reason: Scalars['String']['input'];
};

export type KioskRefundReceiptInput = {
  readonly email: Scalars['String']['input'];
  readonly orderId: Scalars['String']['input'];
};

/** JWT token used to login a user in Kustomer */
export type Kustomer = {
  readonly __typename?: 'Kustomer';
  readonly token: Scalars['String']['output'];
};

export type Ledger = {
  readonly __typename?: 'Ledger';
  /** Items that reduce the post-tax cost (i.e. total) of the order. */
  readonly credits: ReadonlyArray<LedgerItem>;
  /** Sum of all credits */
  readonly creditsTotal: Scalars['Int']['output'];
  /** Items that reduce the pre-tax cost of the order, usually the result of applying offers. */
  readonly discounts: ReadonlyArray<LedgerItem>;
  /** Sum of all discounts */
  readonly discountsTotal: Scalars['Int']['output'];
  readonly fees: ReadonlyArray<LedgerItem>;
  /** Sum of all fees */
  readonly feesTotal: Scalars['Int']['output'];
  /** Loyalty vendor IDs of the selected discounts */
  readonly selectedRewards: ReadonlyArray<Scalars['String']['output']>;
  /** Sum of the cost of all line items. */
  readonly subtotal: Scalars['Int']['output'];
  readonly tax: Scalars['Int']['output'];
  /** Tip applied to order in cents */
  readonly tip: Scalars['Int']['output'];
};

export type LedgerItem = {
  readonly __typename?: 'LedgerItem';
  readonly amount: Scalars['Int']['output'];
  /** May be shown as a tooltip or flyout in clients */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};

export type LineItem = {
  readonly __typename?: 'LineItem';
  /** The ingredients that have been added on to the line item when compared to the product's default ingredients. */
  readonly addedIngredients: ReadonlyArray<Ingredient>;
  /** The total number of calories in the line item */
  readonly calories: Scalars['Int']['output'];
  /** Whether the line item can be reordered at the selected restaurant. */
  readonly canReorderAtRestaurant: Scalars['Boolean']['output'];
  /** The per item cost multiplied by the quantity, in cents. */
  readonly cost: Scalars['Int']['output'];
  /** The custom name for the line item that has been specified by the user. */
  readonly customName: Maybe<Scalars['String']['output']>;
  /** Name of the customer who ordered this lineItem */
  readonly customerName: Scalars['String']['output'];
  /** Dressing status, if the product is dressable. Otherwise NOT_DRESSABLE. */
  readonly dressingMode: DressingMode;
  /** Whether the line item is marked as favorite. */
  readonly favorited: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** The ingredients that make up the line item. These ingredients include any added or removed ingredients compared to the product's default ingredients. */
  readonly ingredients: ReadonlyArray<Ingredient>;
  /** Whether the line item has been customized. */
  readonly isCustom: Scalars['Boolean']['output'];
  /** Information outlining which dressings are mixed into the line item and their associated weights. */
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetails>;
  /** The per item cost of the product as configured, in cents. */
  readonly perItemCost: Scalars['Int']['output'];
  /** The product associated with a line item. */
  readonly product: Product;
  /** The number of products in the line item. */
  readonly quantity: Scalars['Int']['output'];
  /** The ingredients that have been removed from the line item when compared to the product's default ingredients. */
  readonly removedIngredients: ReadonlyArray<Ingredient>;
  readonly slug: Scalars['ID']['output'];
};

export type LineItemCanReorderAtRestaurantArgs = {
  restaurantId: Scalars['Int']['input'];
};

export type LineItemBySlugInput = {
  readonly slug: Scalars['ID']['input'];
};

export type LineItemInput = {
  readonly id: Scalars['ID']['input'];
};

export type LineItemModificationsInvalidException = UserError & {
  readonly __typename?: 'LineItemModificationsInvalidException';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LineItemNotFound = {
  readonly __typename?: 'LineItemNotFound';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LineItemRecommendation = {
  readonly __typename?: 'LineItemRecommendation';
  /** The date and time the recommendation was created. */
  readonly createdAt: Scalars['String']['output'];
  /** The description of the recommendation - commonly the list of ingredients. */
  readonly description: Scalars['String']['output'];
  /** The identifier for the complete item provided by this recommendation. */
  readonly id: Scalars['String']['output'];
  /** The ingredients that make up this recommendation. */
  readonly ingredientIds: ReadonlyArray<Scalars['String']['output']>;
  readonly ingredients: ReadonlyArray<Ingredient>;
  /** The name of the recommendation. */
  readonly name: Scalars['String']['output'];
  /** Whether the recommendation is based on a previous ordered item or is a new item */
  readonly recommendationType: RecommendationType;
};

export type LineItemResponseUnion =
  | LineItemNotFound
  | LineItemSuccess
  | ValidationError;

export type LineItemSuccess = {
  readonly __typename?: 'LineItemSuccess';
  readonly lineItem: LineItem;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly estimateRange: EstimateRange;
  readonly restaurant: Restaurant;
  readonly status: LocationStatus;
  readonly vendor: Vendor;
};

export type LocationByAddressIdInput = {
  /** id for an address present in the current session. */
  readonly addressId: Scalars['ID']['input'];
};

export type LocationByAddressInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  /** id for an address present in the current session. */
  readonly addressId?: InputMaybe<Scalars['ID']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  readonly lat?: InputMaybe<Scalars['Float']['input']>;
  readonly lon?: InputMaybe<Scalars['Float']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly zipcode?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationByAddressResponseUnion =
  | InvalidInput
  | Location
  | NoValidRestaurants
  | ValidationError;

export type LocationByAddressV2Input = {
  readonly address1: Scalars['String']['input'];
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly city: Scalars['String']['input'];
  readonly lat: Scalars['Float']['input'];
  readonly lon: Scalars['Float']['input'];
  readonly state: Scalars['String']['input'];
  readonly zipcode: Scalars['Int']['input'];
};

export type LocationClosed = UserError & {
  readonly __typename?: 'LocationClosed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/**
 * Combines search result meta for match score and with location data
 * Note:
 * - when allLocations are queried the score is 1.0 for every result
 * - for geo-distance queries the score is the distance from the base coodinates
 */
export type LocationSearchResult = {
  readonly __typename?: 'LocationSearchResult';
  readonly location: StoreLocation;
  readonly score: Scalars['Float']['output'];
};

export enum LocationStatus {
  Closed = 'CLOSED',
  Invalid = 'INVALID',
  Open = 'OPEN',
}

export type LogoutInput = {
  readonly customerId: Scalars['ID']['input'];
};

export type LogoutResponseUnion = LogoutSuccess | ValidationError;

export type LogoutSuccess = {
  readonly __typename?: 'LogoutSuccess';
  readonly csrf: Scalars['String']['output'];
};

/** User's loyalty access token to display in the QR code for scanning in store */
export type LoyaltyAccessToken = {
  readonly __typename?: 'LoyaltyAccessToken';
  /** The ISO 8601 timestamp when the token will expire. */
  readonly expiresAt: Scalars['DateTime']['output'];
  /** The JWT to be encoded into the QR code. */
  readonly token: Scalars['String']['output'];
};

/** The purpose of the customer access token. */
export enum LoyaltyAccessTokenPurpose {
  Identify = 'IDENTIFY',
  Payment = 'PAYMENT',
}

/** Error thrown when a user fails to opt into a challenge */
export type LoyaltyOptInFailed = UserError & {
  readonly __typename?: 'LoyaltyOptInFailed';
  readonly errorMessage: Scalars['String']['output'];
};

/** User's loyalty payment metadata to store in the QR code for scanning in store */
export type LoyaltyPaymentMetadata = {
  /** The payment method (credit card) used for the transaction. */
  readonly paymentMethodId: Scalars['String']['input'];
  /** Whether to use credit for the transaction. */
  readonly useCredit: Scalars['Boolean']['input'];
};

/** Customer Loyalty Profile */
export type LoyaltyProfile = {
  readonly __typename?: 'LoyaltyProfile';
  /** External user id */
  readonly customerId: Scalars['ID']['output'];
  readonly customerToken: Maybe<CustomerTokenResponseUnion>;
  /**
   * Customer has subscribed before
   * @deprecated sunsetting sweetpass+
   */
  readonly hasPaidTierHistory: Scalars['Boolean']['output'];
  /** Date the loyalty profile was created */
  readonly joinDate: Scalars['DateTime']['output'];
  /** Loyalty ID (SessionM Profile ID) of the current customer */
  readonly loyaltyId: Maybe<Scalars['String']['output']>;
  readonly points: Maybe<UserPointsStatus>;
  readonly pointsRewards: Maybe<ReadonlyArray<PointsReward>>;
  readonly rewards: Maybe<ReadonlyArray<Reward>>;
  readonly rewardsPremiumStatus: Maybe<RewardsPremiumStatus>;
  /** Customer Tier */
  readonly tier: Maybe<Tier>;
  /** Customer Tier */
  readonly tierStatus: Maybe<TierStatus>;
  /**
   * User trial eligibility. If empty then the user is not eligible
   * @deprecated Free trials are no longer supported
   */
  readonly trialEligible: Maybe<ReadonlyArray<TrialEligibility>>;
};

/** Customer Loyalty Profile */
export type LoyaltyProfileCustomerTokenArgs = {
  paymentMetadata?: InputMaybe<LoyaltyPaymentMetadata>;
  purpose: LoyaltyAccessTokenPurpose;
};

export type LoyaltyScanPaymentTokenInvalid = UserError & {
  readonly __typename?: 'LoyaltyScanPaymentTokenInvalid';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type LoyaltyScanTokenExpired = UserError & {
  readonly __typename?: 'LoyaltyScanTokenExpired';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MaxModificationsExceeded = UserError & {
  readonly __typename?: 'MaxModificationsExceeded';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Menu = {
  readonly __typename?: 'Menu';
  readonly categories: ReadonlyArray<MenuCategory>;
  readonly id: Scalars['String']['output'];
};

export type MenuCategory = {
  readonly __typename?: 'MenuCategory';
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isCustom: Scalars['Boolean']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly products: ReadonlyArray<Product>;
};

export type MenuCollection = {
  readonly __typename?: 'MenuCollection';
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly primaryDescription: Scalars['String']['output'];
  readonly primaryImageUrl: Scalars['String']['output'];
  readonly primaryTitle: Scalars['String']['output'];
  readonly products: ReadonlyArray<Product>;
  readonly secondaryDescription: Maybe<Scalars['String']['output']>;
  readonly secondaryTitle: Maybe<Scalars['String']['output']>;
};

export type MinimumDeliverySubtotalNotMet = UserError & {
  readonly __typename?: 'MinimumDeliverySubtotalNotMet';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type MixedDressingDetails = {
  readonly __typename?: 'MixedDressingDetails';
  readonly ingredientId: Scalars['ID']['output'];
  readonly weight: DressingWeight;
};

export type MixedDressingDetailsInput = {
  readonly ingredientId: Scalars['ID']['input'];
  readonly weight: DressingWeight;
};

export type ModifierGroup = {
  readonly __typename?: 'ModifierGroup';
  readonly allowMultipleQuantity: Scalars['Boolean']['output'];
  readonly displayName: Scalars['String']['output'];
  /** Prompt user to select above the minimum quantity for this modifier group */
  readonly encourageAboveMinSelection: Scalars['Boolean']['output'];
  /** Prompt user to select the maximum quantity for this modifier group */
  readonly encourageMaxSelection: Scalars['Boolean']['output'];
  readonly freeAggregateQuantity: Scalars['Float']['output'];
  /** Helper text displayed to users for this modifier group */
  readonly helperText: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly maxAggregateQuantity: Scalars['Float']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly minAggregateQuantity: Scalars['Float']['output'];
  readonly modifications: ReadonlyArray<IngredientModifier>;
  readonly name: Scalars['String']['output'];
  readonly restaurantId: Scalars['String']['output'];
  /** The variation type for this modifier group */
  readonly variation: ModifierGroupVariation;
};

/** The variation type for a modifier group */
export enum ModifierGroupVariation {
  SplitPortion = 'SPLIT_PORTION',
  Standard = 'STANDARD',
}

export type MultipleBehaviorDetailsUnion = HurdleBehaviorDetails;

export type Mutation = {
  readonly __typename?: 'Mutation';
  /**
   * Adds an address to the customer's list of addresses.
   * @deprecated Migrating away from google place id. Use addAddressV2
   */
  readonly addAddress: AddAddressResponseUnion;
  /** Adds an address to the customer's list of addresses. */
  readonly addAddressV2: AddAddressResponseUnion;
  readonly addLineItemBatchToCart: AddLineItemToCartResponseUnion;
  readonly addLineItemToCart: AddLineItemToCartResponseUnion;
  /** Adds a line item to the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly addLineItemToCartWithLoyalty: AddLineItemToCartResponseUnion;
  readonly anonymizeCustomer: Scalars['Boolean']['output'];
  readonly applyReward: ApplyRewardResponseUnion;
  /** @deprecated Use applyRewardWithLoyalty instead */
  readonly applyRewardByLoyaltyId: ApplyRewardResponseUnion;
  readonly applyRewardWithLoyalty: ApplyRewardResponseUnion;
  /**
   * Attempts to cancel and refund an order.
   * @deprecated Use cancelOrderV2 instead.
   */
  readonly cancelOrder: CancelOrderResponseUnion;
  /** Attempts to cancel an order from an external source. */
  readonly cancelOrderExternal: CancelOrderExternalResponseUnion;
  readonly cancelOrderPaymentIntent: CancelOrderPaymentIntentResponse;
  /** Attempts to cancel and refund an order. */
  readonly cancelOrderV2: CancelOrderResponseUnion;
  /**
   * Takes a challenge ID (a.k.a. SessionM campaign ID) as an argument and opts customer into the identified challenge.  Returns the challenge details upon success. If an error occurs, the error field will be populated in the response: errors[0].message = modal title, errors[0].extension.detailedMessage = modal description/friendly message detailing what went wrong
   * @deprecated Use challengeOptInV2
   */
  readonly challengeOptIn: Challenge;
  /** Takes a challenge ID (a.k.a. SessionM campaign ID) as an argument and opts customer into the identified challenge.  Returns the challenge details upon success. If an error occurs, LoyaltyOptInFailed will be returned with the error details in the error field. */
  readonly challengeOptInV2: ChallengeOptInResultUnion;
  /** Creates a new account for the customer. */
  readonly createAccount: CreateAccountResponseUnion;
  /** Creates and submits an order for a guest customer in a single operation. */
  readonly createAndSubmitPrepaidOrder: SubmitOrderWithPaymentMethodResponseUnion;
  /** Creates a new connection token to pass to the Stripe Terminal SDK */
  readonly createConnectionToken: CreateConnectionTokenResponse;
  /**
   * Creates a new location in Stripe
   * @deprecated No longer supported
   */
  readonly createKioskReaderLocation: CreateKioskReaderLocationIdResponse;
  /** Creates a new location in Stripe with restaurant ID and restaurant entity ID */
  readonly createKioskReaderLocationWithIds: CreateKioskReaderLocationIdResponse;
  readonly createOrderPaymentIntent: PaymentIntent;
  readonly createPaymentIntent: Scalars['String']['output'];
  /** @deprecated Sunsetting sweetpass+ loyalty program */
  readonly createPaymentSubscriptionProfile: PaymentSubscriptionProfile;
  readonly createSetupPaymentIntent: CreateSetupIntent;
  /** Removes an address from the customer's list of addresses. */
  readonly deleteAddress: DeleteAddressResponseUnion;
  readonly deletePaymentMethodCard: PaymentMethodCard;
  readonly editLineItemInCart: EditLineItemInCartResponseUnion;
  /** Edits a line item in the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly editLineItemInCartWithLoyalty: EditLineItemInCartResponseUnion;
  readonly eightySixIngredient: EightySixResponse;
  readonly eightySixProduct: EightySixResponse;
  /** Favorites a Line Item. */
  readonly favoriteLineItem: LineItem;
  readonly identifyAndClaimInStoreOrder: IdentifyAndClaimInStoreOrderResponseUnion;
  /** Issue credit (aka sessionm offers) as sweet touches within the Kustomer platform. */
  readonly issueCustomerSupportCredit: IssueCustomerSupportCreditResult;
  /** Issues a points to a user. */
  readonly issueCustomerSupportPoints: IssueCustomerSupportPointsResponse;
  /** Logs the user out. */
  readonly logout: LogoutResponseUnion;
  /** Opts into the free tier. */
  readonly optInFreeTierV2: Maybe<LoyaltyProfile>;
  /** Opts into the sg rewards loyalty program. */
  readonly optInLoyalty: Maybe<LoyaltyProfile>;
  /** Opts out of loyalty program. */
  readonly optOutLoyalty: OptOutLoyaltyResponseUnion;
  /** Opts a user out of loyalty. Requires a bearer auth token instead of relying on the user session */
  readonly optOutLoyaltyForCustomer: OptOutLoyaltyForCustomerResponseUnion;
  /** Redemption of a gift card */
  readonly redeemGiftCard: RedeemGiftCardResponseUnion;
  /**
   * Refunds a kiosk payment
   * @deprecated No longer supported
   */
  readonly refundKioskPayment: RefundKioskPaymentResponse;
  /** Refunds a kiosk payment. Requires the allow_refunding scope */
  readonly refundKioskPaymentV2: RefundKioskPaymentResponseUnion;
  readonly registerGuest: Maybe<RegisterGuestResponseUnion>;
  readonly removeFromCart: RemoveFromCartResponseUnion;
  /** Removes a line item from the cart with a loyalty ID that will be used to validate applied discounts. This mutation is only available to kiosk clients. */
  readonly removeFromCartWithLoyalty: RemoveFromCartResponseUnion;
  readonly removeReward: RemoveRewardResponseUnion;
  /** @deprecated Use removeRewardWithLoyalty instead */
  readonly removeRewardByLoyaltyId: RemoveRewardResponseUnion;
  readonly removeRewardWithLoyalty: RemoveRewardResponseUnion;
  /** Remove a payment method from a subscription */
  readonly removeSubscriptionPaymentMethod: DeleteSubscriptionPaymentMethodResponseUnion;
  /** @deprecated Deprecated in favor of the "reorderOrder" mutation. */
  readonly reorder: ReorderResponseUnion;
  readonly reorderLineItem: ReorderResponseUnion;
  readonly reorderOrder: ReorderResponseUnion;
  readonly requestAccountDeletion: Maybe<RequestAccountDeletionResponseUnion>;
  /** Sends an refund receipt email */
  readonly sendKioskRefundReceipt: Scalars['Boolean']['output'];
  readonly setDefaultPaymentMethod: PaymentProfile;
  readonly setUserNotificationPreferences: UserNotificationPreferencesUnion;
  /** Signs the user in. */
  readonly signIn: SignInResponseUnion;
  readonly submitFeedback: FeedbackSuccess;
  /** Order a gift card */
  readonly submitGiftCardOrderUsingPaymentMethod: SubmitGiftCardOrderUsingPaymentMethodResponseUnion;
  readonly submitInStoreFeedback: FeedbackSuccess;
  /** Submits an order paid for via a separate workflow i.e. marketplace. */
  readonly submitOrderAsPayInStore: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for via a separate workflow i.e. marketplace without a wanted time */
  readonly submitOrderAsPayInStoreASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for via a separate workflow i.e. marketplace. */
  readonly submitOrderAsPrepaid: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for via a separate workflow i.e. marketplace without a wanted time */
  readonly submitOrderAsPrepaidASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order with an already confirmed payment intent. */
  readonly submitOrderUsingPaymentIntent: SubmitOrderUsingPaymentIntentResponseUnion;
  /** Submits an order, paid for using one of the customer's existing payment methods. */
  readonly submitOrderUsingPaymentMethod: SubmitOrderUsingPaymentMethodResponseUnion;
  /**
   * Submits an order, paid for using one of the customer's existing billing accounts.
   * @deprecated Use the submitOrderUsingPaymentMethod mutation instead
   */
  readonly submitOrderUsingPaymentMethodCard: SubmitOrderUsingBillingAccountResponseUnion;
  /** Submits an order paid for via a separate workflow without a wanted time with Loyalty ID-based loyalty support, for kiosks. */
  readonly submitOrderWithLoyaltyAsPrepaidASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid in-store without a wanted time with Loyalty ID-based loyalty support, for kiosks. */
  readonly submitOrderWithLoyaltyAsPrepaidInStoreASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for with the scan to pay QRCode token, for kiosks. */
  readonly submitOrderWithLoyaltyUsingPaymentMethodASAP: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits an order paid for via a separate workflow i.e. marketplace. */
  readonly submitOrderWithPaymentMethod: SubmitOrderWithPaymentMethodResponseUnion;
  /** Submits code to SessionM. */
  readonly submitPromoCode: SubmitPromoCodeResponseUnion;
  /**
   * Submits code to SessionM. If unsuccessful, code is submitted to LevelUp.
   * @deprecated Deprecated in favor of submitPromoCode
   */
  readonly submitPromoOrGiftCardCode: SubmitPromoCodeOrGiftCardResponseUnion;
  readonly syncLocation: SyncLocationResult;
  /**
   * Updates an address form the customer's list of addresses.
   * @deprecated Migrating away from google place id. Use updateAddressV2
   */
  readonly updateAddress: UpdateAddressResponseUnion;
  /** Updates an address form the customer's list of addresses. */
  readonly updateAddressV2: UpdateAddressResponseUnion;
  readonly updateCustomer: Maybe<UpdateCustomerResponse>;
  readonly updateKioskCustomer: Maybe<UpdateKioskCustomerResponse>;
  readonly updatePaymentMethod: PaymentMethodCard;
  readonly updatePreferences: UpdateCustomerPreferencesUnion;
  /** Sets whether to use credit on next purchase. */
  readonly updateUseCredit: UpdateUseCreditResponse;
  /** Returns whether a redemption token is valid and generates a new token */
  readonly validateAndRefreshGiftCardRedemptionTokenForCustomer: ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse;
};

export type MutationAddAddressArgs = {
  input: AddAddressInput;
};

export type MutationAddAddressV2Args = {
  input: AddAddressV2Input;
};

export type MutationAddLineItemBatchToCartArgs = {
  input: AddLineItemBatchToCartInput;
};

export type MutationAddLineItemToCartArgs = {
  input: AddLineItemToCartInput;
};

export type MutationAddLineItemToCartWithLoyaltyArgs = {
  input: AddLineItemToCartWithLoyaltyInput;
};

export type MutationAnonymizeCustomerArgs = {
  input: AnonymizeCustomerInput;
};

export type MutationApplyRewardArgs = {
  input: ApplyRewardInput;
};

export type MutationApplyRewardByLoyaltyIdArgs = {
  input: ApplyRewardByLoyaltyIdInput;
};

export type MutationApplyRewardWithLoyaltyArgs = {
  input: ApplyRewardWithLoyaltyInput;
};

export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};

export type MutationCancelOrderExternalArgs = {
  input: CancelExternalOrderInput;
};

export type MutationCancelOrderPaymentIntentArgs = {
  input: CancelOrderPaymentIntentInput;
};

export type MutationCancelOrderV2Args = {
  input: CancelOrderInput;
};

export type MutationChallengeOptInArgs = {
  challengeId: Scalars['String']['input'];
};

export type MutationChallengeOptInV2Args = {
  challengeId: Scalars['String']['input'];
};

export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};

export type MutationCreateAndSubmitPrepaidOrderArgs = {
  input: CreateAndSubmitOrderInput;
};

export type MutationCreateKioskReaderLocationArgs = {
  restaurantInfo: RestaurantLocationInfoInputDto;
};

export type MutationCreateKioskReaderLocationWithIdsArgs = {
  restaurantInfo: RestaurantLocationInfoWithIdsInput;
};

export type MutationCreateOrderPaymentIntentArgs = {
  input: CreateOrderPaymentIntentInput;
};

export type MutationDeleteAddressArgs = {
  addressId: Scalars['ID']['input'];
};

export type MutationDeletePaymentMethodCardArgs = {
  input: DeletePaymentMethodCardInput;
};

export type MutationEditLineItemInCartArgs = {
  input: EditLineItemInCartInput;
};

export type MutationEditLineItemInCartWithLoyaltyArgs = {
  input: EditLineItemInCartWithLoyaltyInput;
};

export type MutationEightySixIngredientArgs = {
  input: EightySixIngredientInput;
};

export type MutationEightySixProductArgs = {
  input: EightySixProductInput;
};

export type MutationFavoriteLineItemArgs = {
  input: FavoriteLineItemInput;
};

export type MutationIdentifyAndClaimInStoreOrderArgs = {
  input: IdentifyAndClaimInStoreOrderInput;
};

export type MutationIssueCustomerSupportCreditArgs = {
  creditId: Scalars['String']['input'];
  legacyInternalId: Scalars['String']['input'];
};

export type MutationIssueCustomerSupportPointsArgs = {
  legacyInternalId: Scalars['ID']['input'];
  numberOfPoints: Scalars['Int']['input'];
};

export type MutationLogoutArgs = {
  input: LogoutInput;
};

export type MutationOptOutLoyaltyForCustomerArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  legacyInternalId?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRedeemGiftCardArgs = {
  code: Scalars['String']['input'];
  regCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefundKioskPaymentArgs = {
  refundParameters: KioskRefundInput;
};

export type MutationRefundKioskPaymentV2Args = {
  refundParameters: KioskRefundInput;
};

export type MutationRegisterGuestArgs = {
  input: RegisterGuestInput;
};

export type MutationRemoveFromCartArgs = {
  input: RemoveFromCartInput;
};

export type MutationRemoveFromCartWithLoyaltyArgs = {
  input: RemoveFromCartWithLoyaltyInput;
};

export type MutationRemoveRewardArgs = {
  input: RemoveRewardInput;
};

export type MutationRemoveRewardByLoyaltyIdArgs = {
  input: RemoveRewardByLoyaltyIdInput;
};

export type MutationRemoveRewardWithLoyaltyArgs = {
  input: RemoveRewardWithLoyaltyInput;
};

export type MutationRemoveSubscriptionPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};

export type MutationReorderArgs = {
  input: ReorderInput;
};

export type MutationReorderLineItemArgs = {
  input: ReorderInput;
};

export type MutationReorderOrderArgs = {
  input: ReorderInput;
};

export type MutationSendKioskRefundReceiptArgs = {
  refundReceiptParameters: KioskRefundReceiptInput;
};

export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};

export type MutationSetUserNotificationPreferencesArgs = {
  input: NotificationPreferencesInput;
};

export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitGiftCardOrderUsingPaymentMethodArgs = {
  input: SubmitGiftCardOrderUsingPaymentMethodInput;
};

export type MutationSubmitInStoreFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitOrderAsPayInStoreArgs = {
  input: SubmitOrderInput;
};

export type MutationSubmitOrderAsPayInStoreAsapArgs = {
  input: SubmitOrderAsapInput;
};

export type MutationSubmitOrderAsPrepaidArgs = {
  input: SubmitOrderInput;
};

export type MutationSubmitOrderAsPrepaidAsapArgs = {
  input: SubmitOrderAsapInput;
};

export type MutationSubmitOrderUsingPaymentIntentArgs = {
  input: SubmitOrderUsingPaymentIntentInput;
};

export type MutationSubmitOrderUsingPaymentMethodArgs = {
  input: SubmitOrderUsingPaymentMethodInput;
};

export type MutationSubmitOrderUsingPaymentMethodCardArgs = {
  input: SubmitOrderUsingPaymentMethodCardInput;
};

export type MutationSubmitOrderWithLoyaltyAsPrepaidAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithLoyaltyAsPrepaidInStoreAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithLoyaltyUsingPaymentMethodAsapArgs = {
  input: SubmitOrderAsapWithLoyaltyInput;
};

export type MutationSubmitOrderWithPaymentMethodArgs = {
  input: SubmitOrderWithPaymentMethodInput;
};

export type MutationSubmitPromoCodeArgs = {
  input: SubmitPromoCodeInput;
};

export type MutationSubmitPromoOrGiftCardCodeArgs = {
  input: SubmitPromoOrGiftCardCodeInput;
};

export type MutationSyncLocationArgs = {
  input: SyncLocationInput;
};

export type MutationUpdateAddressArgs = {
  input: EditAddressInput;
};

export type MutationUpdateAddressV2Args = {
  input: EditAddressV2Input;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

export type MutationUpdateKioskCustomerArgs = {
  input: UpdateKioskCustomerInput;
};

export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};

export type MutationUpdatePreferencesArgs = {
  input: CustomerPreferencesInput;
};

export type MutationUpdateUseCreditArgs = {
  useCredit: Scalars['Boolean']['input'];
};

export type MutationValidateAndRefreshGiftCardRedemptionTokenForCustomerArgs = {
  input: ValidateAndRefreshGiftCardRedemptionTokenForCustomerInput;
};

/** "No Balance Gift card" user error */
export type NoBalanceGiftCardError = UserError & {
  readonly __typename?: 'NoBalanceGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

export type NoValidRestaurants = {
  readonly __typename?: 'NoValidRestaurants';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Notification Category */
export type NotificationCategory = {
  readonly __typename?: 'NotificationCategory';
  readonly displayName: Scalars['String']['output'];
  readonly emailSubscribe: Scalars['Boolean']['output'];
  readonly hasResolved: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  readonly pushSubscribe: Scalars['Boolean']['output'];
};

export type NotificationCategoryInput = {
  readonly emailSubscribe: Scalars['Boolean']['input'];
  readonly id: Scalars['String']['input'];
  readonly pushSubscribe: Scalars['Boolean']['input'];
};

export type NotificationPreferencesError = UserError & {
  readonly __typename?: 'NotificationPreferencesError';
  readonly errorMessage: Scalars['String']['output'];
};

export type NotificationPreferencesInput = {
  readonly notificationCategories: ReadonlyArray<NotificationCategoryInput>;
};

export enum NotificationType {
  LiveActivity = 'LIVE_ACTIVITY',
  Push = 'PUSH',
  Sms = 'SMS',
}

export type OpenLoyaltyTransactionDetailsInput = {
  readonly createdAt: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly isInFlight: Scalars['Boolean']['input'];
  readonly isInFlightDelivery: Scalars['Boolean']['input'];
  readonly lineItems: ReadonlyArray<OrderLineItemInput>;
  readonly orderType: Scalars['String']['input'];
  readonly restaurantEntityId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantParentId?: InputMaybe<Scalars['Float']['input']>;
  readonly restaurantUtcOffset?: InputMaybe<Scalars['Float']['input']>;
  readonly selectedRewards?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']>
  >;
  readonly subtotal: Scalars['Float']['input'];
  readonly tax: Scalars['Float']['input'];
  readonly updatedAt?: InputMaybe<Scalars['String']['input']>;
  readonly wantedTime?: InputMaybe<Scalars['String']['input']>;
};

export type OptOutLoyaltyForCustomerResponseUnion =
  | OptOutLoyaltyForCustomerSuccessResponse
  | UnknownUserError;

/** Opt Out Loyalty For Customer Result */
export type OptOutLoyaltyForCustomerSuccessResponse = {
  readonly __typename?: 'OptOutLoyaltyForCustomerSuccessResponse';
  /** Indicates if the user has successfully been opted out */
  readonly success: Scalars['Boolean']['output'];
};

export type OptOutLoyaltyResponseUnion =
  | OptOutLoyaltySuccessResponse
  | UnknownUserError;

/** Opt Out Loyalty Result */
export type OptOutLoyaltySuccessResponse = {
  readonly __typename?: 'OptOutLoyaltySuccessResponse';
  /** Indicates if the user has successfully been opted out */
  readonly success: Scalars['Boolean']['output'];
};

/** Order */
export type Order = {
  readonly __typename?: 'Order';
  readonly asset: Asset;
  /** All non-points rewards that are issued to this customer, regardless of eligibility to this order. */
  readonly availableRewards: Maybe<ReadonlyArray<Reward>>;
  /** All non-points rewards that are issued to this customer (looked up by their loyalty ID), regardless of eligibility to this order. */
  readonly availableRewardsByLoyaltyId: Maybe<ReadonlyArray<Reward>>;
  /** All non-points rewards that are issued to this customer (looked up by their customer token), regardless of eligibility to this order. */
  readonly availableRewardsWithLoyalty: Maybe<ReadonlyArray<Reward>>;
  readonly availableWantedTimes: ReadonlyArray<AvailableWantedTime>;
  /** Checks if this order is in the received state, but only if the wanted time is recent (12hrs). */
  readonly canCancel: Scalars['Boolean']['output'];
  /** Whether or not this order belongs to a restaurant with support for tracking the orders with a QSR system. This is always true for delivery orders, for pickup or outpost, it checks the tracking status of the restaurant. This flag affects what we should the customer in the order status feature. */
  readonly canTrackOrderStatus: Scalars['Boolean']['output'];
  readonly deliveryOrderDetail: Maybe<DeliveryOrderDetail>;
  readonly description: Scalars['String']['output'];
  readonly dropoffLocation: Maybe<Scalars['String']['output']>;
  /** All points rewards that are issued to this customer and are eligible to this order. */
  readonly eligiblePointRewards: Maybe<ReadonlyArray<PointsReward>>;
  /** All points rewards that are issued to this customer (lookup by loyalty ID) and are eligible to this order. */
  readonly eligiblePointRewardsByLoyaltyId: Maybe<ReadonlyArray<PointsReward>>;
  /** All points rewards that are issued to this customer (lookup by their customer token) and are eligible to this order. */
  readonly eligiblePointRewardsWithLoyalty: Maybe<ReadonlyArray<PointsReward>>;
  /** Whether the customer has earned loyalty points for this order */
  readonly hasEarnedLoyaltyPoints: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly includeUtensils: Scalars['Boolean']['output'];
  /** Indicates whether the order was canceled. */
  readonly isCanceled: Scalars['Boolean']['output'];
  /** Whether or not this order is an inflight order, this is done by checking the session.inFlightOrderId on a field resolver. */
  readonly isInFlight: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not this order is an inflight delivery order, this is done by checking the session.inFlightDeliveryOrderId on a field resolver. */
  readonly isInFlightDelivery: Scalars['Boolean']['output'];
  /** Whether or not this order is pending the feedback from "rate your order". */
  readonly isPendingFeedback: Scalars['Boolean']['output'];
  readonly ledger: Ledger;
  readonly lineItems: ReadonlyArray<LineItem>;
  readonly orderSource: Maybe<OrderSource>;
  readonly orderType: OrderType;
  readonly payments: Maybe<ReadonlyArray<Payment>>;
  readonly restaurant: Restaurant;
  readonly total: Maybe<Scalars['Int']['output']>;
  /** Used by customers to reference the order when speaking to our support team. */
  readonly vendorId: Scalars['String']['output'];
  readonly wantedTime: Scalars['DateTime']['output'];
};

/** Order */
export type OrderAvailableRewardsByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

/** Order */
export type OrderAvailableRewardsWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

/** Order */
export type OrderEligiblePointRewardsByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

/** Order */
export type OrderEligiblePointRewardsWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

/** Order has already been canceled */
export type OrderAlreadyCanceled = UserError & {
  readonly __typename?: 'OrderAlreadyCanceled';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

/** Order sent to kitchen */
export type OrderAlreadySentToKitchen = UserError & {
  readonly __typename?: 'OrderAlreadySentToKitchen';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type OrderConflict = {
  readonly __typename?: 'OrderConflict';
  readonly product: Product;
  /** Reorder conflict type */
  readonly type: ConflictType;
  readonly unavailableIngredients: ReadonlyArray<Ingredient>;
};

export type OrderLineItemInput = {
  readonly brinkPlu: Scalars['Float']['input'];
  readonly cost: Scalars['Float']['input'];
  readonly id?: InputMaybe<Scalars['Float']['input']>;
  readonly parentLineItemId?: InputMaybe<Scalars['Float']['input']>;
  readonly perItemCost: Scalars['Float']['input'];
  readonly quantity: Scalars['Float']['input'];
};

/** Order not found */
export type OrderNotFound = UserError & {
  readonly __typename?: 'OrderNotFound';
  readonly errorMessage: Scalars['String']['output'];
  readonly orderId: Scalars['ID']['output'];
  /** Boolean representing if the order successfully canceled or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type OrderPaymentInput = {
  readonly amountEligibleForPointsInCents?: InputMaybe<
    Scalars['Float']['input']
  >;
  readonly amountInCents: Scalars['Float']['input'];
  readonly id: Scalars['String']['input'];
  readonly paymentTime: Scalars['String']['input'];
  readonly processor: Scalars['String']['input'];
};

export type OrderPaymentState = {
  readonly __typename?: 'OrderPaymentState';
  readonly createdAt: Scalars['String']['output'];
  readonly error: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly paymentIntentId: Scalars['String']['output'];
  readonly paymentIntentSecret: Scalars['String']['output'];
  readonly status: OrderPaymentStatus;
  readonly updatedAt: Scalars['String']['output'];
};

export enum OrderPaymentStatus {
  Approved = 'Approved',
  Created = 'Created',
  Failed = 'Failed',
  Fulfilled = 'Fulfilled',
  Released = 'Released',
}

export enum OrderSource {
  DoordashMarketplace = 'DOORDASH_MARKETPLACE',
  EzcaterMarketplace = 'EZCATER_MARKETPLACE',
  FoodaMarketplace = 'FOODA_MARKETPLACE',
  GenericMarketplace = 'GENERIC_MARKETPLACE',
  GrubhubMarketplace = 'GRUBHUB_MARKETPLACE',
  Kiosk = 'KIOSK',
  MealpalMarketplace = 'MEALPAL_MARKETPLACE',
  Native = 'NATIVE',
  SharebiteMarketplace = 'SHAREBITE_MARKETPLACE',
  UberEatsMarketplace = 'UBER_EATS_MARKETPLACE',
}

export type OrderStatus = {
  readonly __typename?: 'OrderStatus';
  readonly canceledStatus: Maybe<Scalars['String']['output']>;
  readonly courierDetails: Maybe<CourierDetails>;
  readonly customerId: Scalars['ID']['output'];
  readonly deliveryAddressName: Maybe<Scalars['String']['output']>;
  /** Flattened list of order statuses, which collapses the different per order type order statuses into a standard list. */
  readonly flattenedOrderStatus: FlattenedOrderStatuses;
  readonly gravyStatus: GravyStatusType;
  readonly gravyUpdatedAt: Scalars['String']['output'];
  readonly order: Order;
  readonly orderId: Maybe<Scalars['ID']['output']>;
  readonly orderOccasion: Scalars['String']['output'];
  /** Raw list of order statuses, each status comes with the order type and there are multiple variants per each step. */
  readonly orderStatus: Scalars['String']['output'];
  readonly orderWantedTime: Maybe<Scalars['String']['output']>;
  readonly restaurantName: Maybe<Scalars['String']['output']>;
};

export type OrderStatusResponseUnion = InvalidOrder | OrderStatus;

export enum OrderType {
  Catering = 'CATERING',
  Delivery = 'DELIVERY',
  InStore = 'IN_STORE',
  Pickup = 'PICKUP',
}

export type OrdersInput = {
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type OrdersInputV2 = {
  readonly includeCanceledOrders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly includePlacedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  readonly page: Scalars['Int']['input'];
  readonly take: Scalars['Int']['input'];
};

export type OrdersResponseSuccess = {
  readonly __typename?: 'OrdersResponseSuccess';
  readonly orders: ReadonlyArray<Order>;
  readonly pagination: Pagination;
};

export type OrdersResponseUnion = OrdersResponseSuccess | ValidationError;

export type Pagination = {
  readonly __typename?: 'Pagination';
  /** Last available page. */
  readonly last: Scalars['Int']['output'];
  /** The page requested. */
  readonly page: Scalars['Int']['output'];
  /** Items per page. */
  readonly take: Scalars['Int']['output'];
  /** Total number of items available. */
  readonly total: Scalars['Int']['output'];
};

/** Payment entity */
export type Payment = {
  readonly __typename?: 'Payment';
  /** How much of this payment is eligible for points */
  readonly amountEligibleForPoints: Scalars['Float']['output'];
  readonly amountInCents: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  /** Credit card last4 */
  readonly last4: Maybe<Scalars['String']['output']>;
  readonly paymentTime: Scalars['DateTime']['output'];
  readonly processor: Scalars['String']['output'];
  /** Is payment fully refunded */
  readonly refunded: Maybe<Scalars['Boolean']['output']>;
  /** Amount refunded in cents */
  readonly refundedAmount: Maybe<Scalars['Float']['output']>;
  /** Credit card type */
  readonly type: Maybe<Scalars['String']['output']>;
};

export type PaymentAlreadyRefunded = UserError & {
  readonly __typename?: 'PaymentAlreadyRefunded';
  readonly errorMessage: Scalars['String']['output'];
};

export type PaymentIntent = {
  readonly __typename?: 'PaymentIntent';
  readonly id: Scalars['ID']['output'];
  readonly secret: Scalars['String']['output'];
};

export type PaymentIntentDeliveryOrderDetail = {
  readonly addressId: Scalars['ID']['input'];
  readonly deliveryFee: Scalars['Float']['input'];
  readonly tip: Scalars['Float']['input'];
  readonly vendor: Scalars['String']['input'];
  readonly vendorRestaurantId: Scalars['String']['input'];
};

export type PaymentMethodBillingAccount = {
  readonly __typename?: 'PaymentMethodBillingAccount';
  /** The type of card */
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCard = {
  readonly __typename?: 'PaymentMethodCard';
  /** The type of card */
  readonly cardType: CardType;
  /** Computed display name containing card type and last 4 digits */
  readonly description: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  /** User-supplied alias */
  readonly nickname: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCardUnion =
  | PaymentMethodBillingAccount
  | PaymentMethodCard;

export enum PaymentMethods {
  PaymentIntent = 'PAYMENT_INTENT',
  PaymentMethodCard = 'PAYMENT_METHOD_CARD',
  PayInStore = 'PAY_IN_STORE',
  Prepaid = 'PREPAID',
}

/** Payment Plan */
export type PaymentPlan = {
  readonly __typename?: 'PaymentPlan';
  /** ID of plan from Braintree */
  readonly braintreePlanId: Scalars['ID']['output'];
  /** Tier plan belongs to */
  readonly tier: Tier;
};

/** Customer Payment Profile */
export type PaymentProfile = {
  readonly __typename?: 'PaymentProfile';
  readonly defaultCardId: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
};

/** Customer Subscription object */
export type PaymentSubscription = {
  readonly __typename?: 'PaymentSubscription';
  readonly balance: Scalars['String']['output'];
  /**
   * The frequency in which subscription payments should be made.
   * @deprecated Deprecated in favor of `billingRecurrence`
   */
  readonly billingFrequencyUnit: Maybe<DurationUnit>;
  readonly billingHistory: ReadonlyArray<SubscriptionTransactions>;
  readonly billingPeriodEndDate: Maybe<Scalars['String']['output']>;
  readonly billingPeriodStartDate: Maybe<Scalars['String']['output']>;
  /** The recurrence in which subscription payments should be made. */
  readonly billingRecurrence: Maybe<DurationUnit>;
  readonly createdAt: Scalars['String']['output'];
  /** The first billing date of this subscription. */
  readonly firstBillingDate: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if the subscription has a free trial associated with it. */
  readonly hasFreeTrial: Scalars['Boolean']['output'];
  /** The ID of the subscription */
  readonly id: Scalars['ID']['output'];
  /** Indicates if the subscription is currently on a free trial (was not paid for yet). */
  readonly isTrialActive: Scalars['Boolean']['output'];
  readonly nextBillingDate: Scalars['String']['output'];
  readonly nextBillingPeriodAmount: Scalars['String']['output'];
  readonly paidThroughDate: Maybe<Scalars['DateTime']['output']>;
  readonly planId: Scalars['String']['output'];
  readonly price: Maybe<Scalars['String']['output']>;
  readonly status: PaymentSubscriptionStatus;
};

/** Braintree Customer Payment Subscription Profile (deprecated) */
export type PaymentSubscriptionProfile = {
  readonly __typename?: 'PaymentSubscriptionProfile';
  readonly creditCards: Maybe<ReadonlyArray<SubscriptionCreditCard>>;
  readonly id: Scalars['ID']['output'];
  readonly transactionHistory: ReadonlyArray<SubscriptionTransactions>;
};

export enum PaymentSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Expired = 'Expired',
  PastDue = 'PastDue',
  Pending = 'Pending',
}

/** Point expiration information */
export type PointExpirationEntry = {
  readonly __typename?: 'PointExpirationEntry';
  readonly amountExpiring: Scalars['Int']['output'];
  readonly id: Scalars['Int']['output'];
  readonly numOfDaysUntilExpiration: Scalars['Int']['output'];
};

/** Point History Entry */
export type PointHistoryEntry = {
  readonly __typename?: 'PointHistoryEntry';
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['String']['output'];
  readonly source: Maybe<PointIssuanceSource>;
  readonly type: Maybe<PointHistoryEntryType>;
  readonly value: Scalars['Int']['output'];
};

/** The type of the point history entry */
export enum PointHistoryEntryType {
  Earned = 'EARNED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED',
  Removed = 'REMOVED',
}

/** Point History For User Error */
export type PointHistoryForUserError = {
  readonly __typename?: 'PointHistoryForUserError';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type PointHistoryForUserResponseUnion =
  | PointHistoryForUserError
  | PointHistoryForUserSuccess;

/** Point History For User Success */
export type PointHistoryForUserSuccess = {
  readonly __typename?: 'PointHistoryForUserSuccess';
  readonly pagination: Pagination;
  readonly pointExpirationEntries: ReadonlyArray<PointExpirationEntry>;
  /** Point history entries. Can contain null values as a result of serialization failures. */
  readonly pointHistoryEntries: ReadonlyArray<Maybe<PointHistoryEntry>>;
};

/** The source of the points issuance */
export enum PointIssuanceSource {
  BonusPoints = 'BONUS_POINTS',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  MultipleSources = 'MULTIPLE_SOURCES',
  OfferCompletion = 'OFFER_COMPLETION',
  Order = 'ORDER',
  Sweetgreen = 'SWEETGREEN',
  VoidedOrder = 'VOIDED_ORDER',
}

export type PointsReward = {
  readonly __typename?: 'PointsReward';
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly points: Scalars['Float']['output'];
  readonly redeemable: Scalars['Boolean']['output'];
};

export type Product = {
  readonly __typename?: 'Product';
  readonly asset: Asset;
  /** Date that product will be available */
  readonly availableDate: Maybe<Scalars['String']['output']>;
  readonly baseProduct: BaseProduct;
  readonly calories: Scalars['Int']['output'];
  /** @deprecated Not being used anymore by the client. */
  readonly categoryId: Scalars['String']['output'];
  /** @deprecated Not being used anymore by the client. */
  readonly categoryName: Scalars['String']['output'];
  /** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are is implicit based on the request and restaurant. */
  readonly channelCost: Scalars['Int']['output'];
  /** Base cost, in cents */
  readonly cost: Scalars['Int']['output'];
  /** If a product is custom, this field provides the type of that product, otherwise the field will be null. Clients must only use this field for cosmetic purposes; for example, displaying a custom product card on the menu page. */
  readonly customType: Maybe<CustomProductType>;
  readonly description: Scalars['String']['output'];
  readonly dietaryProperties: ReadonlyArray<DietaryProperty>;
  /** Indicates whether dressing details should be displayed for this product */
  readonly enableDressingDetails: Scalars['Boolean']['output'];
  /** Date that product will no longer be valid */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ingredientModifications: IngredientModifications;
  readonly ingredients: ReadonlyArray<Ingredient>;
  readonly isCustom: Scalars['Boolean']['output'];
  readonly isMixable: Maybe<Scalars['Boolean']['output']>;
  readonly isModifiable: Scalars['Boolean']['output'];
  readonly isSalad: Scalars['Boolean']['output'];
  readonly label: Maybe<ProductLabel>;
  /** Master product ID from gravy database */
  readonly masterProductId: Maybe<Scalars['Int']['output']>;
  /** The total number of additions, removals, and substitutions that are allowed to be modified for this product */
  readonly maxModifications: Scalars['Int']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly modifierGroups: ReadonlyArray<ModifierGroup>;
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
  readonly restaurant: Restaurant;
  readonly restaurantId: Scalars['ID']['output'];
  readonly slug: Scalars['String']['output'];
  readonly throttleItem: Scalars['Boolean']['output'];
};

export type ProductChannelCostArgs = {
  costChannel?: InputMaybe<CostChannel>;
};

export type ProductLabel = {
  readonly __typename?: 'ProductLabel';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type ProductOutOfStock = UserError & {
  readonly __typename?: 'ProductOutOfStock';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type ProductUnavailable = UserError & {
  readonly __typename?: 'ProductUnavailable';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Promo code has already been applied */
export type PromoCodeAlreadyApplied = UserError & {
  readonly __typename?: 'PromoCodeAlreadyApplied';
  readonly errorMessage: Scalars['String']['output'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly addons: Addons;
  readonly address: Maybe<Address>;
  /** Returns all sweetgreen locations (that aren't hidden etc) */
  readonly allLocations: Maybe<ReadonlyArray<Maybe<LocationSearchResult>>>;
  /** Returns available loyalty point options */
  readonly availableCustomerSupportPoints: AvailableCustomerSupportPointsResponseUnion;
  readonly baseProduct: Maybe<BaseProduct>;
  /**
   * Returns if an order can be canceled and the amount of minutes before the order cannot be canceled.
   * @deprecated Use canCancelV2 instead.
   */
  readonly canCancel: ReadonlyArray<CanCancelResponseUnion>;
  /** Returns if an order can be canceled and the amount of minutes before the order cannot be canceled. */
  readonly canCancelV2: ReadonlyArray<CanCancelResponseUnion>;
  readonly cart: Maybe<Order>;
  readonly categoryUpsells: ReadonlyArray<UpsellCategory>;
  /** Fetch catering orders for a restaurant */
  readonly cateringOrders: CateringOrdersResponse;
  /**
   * Returns the challenge celebration details available for a customer from newly completed challenges. If multiple challenges have been newly completed, returns hardcoded description and disclaimer with no title or expirationDate. Returns null if customer has already viewed celebration messaging.
   * @deprecated Deprecated in favor of the "challengeCelebrationModal" query.
   */
  readonly challengeCelebration: Maybe<ChallengeCelebration>;
  /** Returns the challenge celebration details available for a customer from newly completed challenges. Returns null if customer has already viewed celebration messaging. */
  readonly challengeCelebrationV2: Maybe<ChallengeCelebrationV2>;
  /**
   * Returns all eligible rewards available to the customer
   * @deprecated Fetching rewards for user should be done through loyaltyProfile
   */
  readonly challengeRewards: ReadonlyArray<ChallengeReward>;
  /** Returns customers eligible challenges */
  readonly challenges: ReadonlyArray<Challenge>;
  /** JWT token used to login the user in a chat app. */
  readonly chatToken: Maybe<ChatToken>;
  readonly currentCustomer: Maybe<Customer>;
  readonly customerExists: Scalars['Boolean']['output'];
  /** Pass card for scan to pay, usually for adding to apple wallet */
  readonly customerPass: Maybe<CustomerPass>;
  readonly customerPaymentInfo: CustomerPaymentInfo;
  /** Returns the loyalty points for a user. */
  readonly customerPointsForCustomerSupport: CustomerPointsForCustomerSupportResponseUnion;
  /** Returns available credits allocated for customer support team to issue. Requires a bearer auth token. */
  readonly customerSupportCredits: CustomerSupportCreditsResponseUnion;
  readonly favoritedLineItems: ReadonlyArray<LineItem>;
  readonly feedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  /**
   * Returns all plans associated to tierId
   * @deprecated Sunsetting sweetpass+
   */
  readonly fetchPlansByTierId: Maybe<ReadonlyArray<PaymentPlan>>;
  /** Get all payments for specified date and restaurant */
  readonly getKioskPaymentsForCurrentDate: GetKioskPaymentsForCurrentDateResponse;
  /** Get the Kiosk Reader Location ID */
  readonly getKioskReaderLocationId: Maybe<GetKioskReaderLocationIdResponse>;
  /** Get the Kiosk Reader Location ID by Restaurant ID */
  readonly getKioskReaderLocationIdByEntityId: Maybe<GetKioskReaderLocationIdResponse>;
  /** Get the Kiosk Reader Location ID by Restaurant ID */
  readonly getKioskReaderLocationIdByRestaurantId: Maybe<GetKioskReaderLocationIdResponse>;
  /** @deprecated Use orderPaymentState instead */
  readonly getOrderPaymentState: Maybe<OrderPaymentState>;
  readonly getOrderStatusNotificationPreferences: NotificationCategory;
  readonly getPreferences: CustomerPreference;
  readonly getSubscriptions: ReadonlyArray<PaymentSubscription>;
  readonly getUserNotificationPreferences: UserNotificationPreferencesUnion;
  /** Customer's gift card balance */
  readonly giftCardBalance: GiftCardBalanceResponseUnion;
  /** Customer's gift card order detail */
  readonly giftCardOrderDetail: GiftCardOrderDetailResponseUnion;
  /** Customer's gift card purchase history */
  readonly giftCardPurchaseHistory: GiftCardPurchaseHistory;
  /** Gift card redepmtion details */
  readonly giftCardRedemptionDetail: GiftCardRedemptionDetailResponseUnion;
  /** Returns a boolean indicating if user has any unseen challenges */
  readonly hasUnseenChallenges: HasUnseenChallenges;
  readonly inStoreFeedbackQuestions: ReadonlyArray<FeedbackQuestion>;
  /** Returns the specified in store order for this customer */
  readonly inStoreLoyaltyOrder: Maybe<InStoreOrder>;
  /** Returns all in store orders for this customer */
  readonly inStoreLoyaltyOrders: InStoreOrdersResponse;
  /** @deprecated LU scan-to-pay is no longer supported. */
  readonly inStoreOrderLastPendingFeedback: Maybe<InStoreOrder>;
  readonly inStorePaymentMethods: ReadonlyArray<Credit>;
  /** Returns customer's profile by loyalty ID (aka SessionM customer ID) */
  readonly kioskCustomerProfile: Maybe<KioskCustomerProfile>;
  /** Resolves default payment card info and credit balance for scan-to-pay customers */
  readonly kioskCustomerScanPaymentInfo: KioskCustomerScanPaymentInfoResponse;
  /** Kustomer JWT token used to login the user in Kustomer */
  readonly kustomerToken: Maybe<Kustomer>;
  readonly lineItem: Maybe<LineItemResponseUnion>;
  readonly lineItemBySlug: Maybe<LineItemResponseUnion>;
  readonly lineItemRecommendations: ReadonlyArray<LineItemRecommendation>;
  /** @deprecated Migrating away from google place id. Use either locationByAddressV2 or locationByAddressId. */
  readonly locationByAddress: LocationByAddressResponseUnion;
  readonly locationByAddressId: LocationByAddressResponseUnion;
  readonly locationByAddressV2: LocationByAddressResponseUnion;
  /** Returns existing loyalty profile, otherwise creates one */
  readonly loyaltyProfile: Maybe<LoyaltyProfile>;
  /**
   * Returns existing loyalty profile based on the provided `loyaltyId`
   * @deprecated Use loyaltyProfileWithLoyalty instead
   */
  readonly loyaltyProfileByLoyaltyId: LoyaltyProfile;
  /** Returns existing loyalty profile based on the provided `loyaltyId` */
  readonly loyaltyProfileWithLoyalty: LoyaltyProfile;
  readonly menuCollection: MenuCollection;
  readonly menuCollections: ReadonlyArray<MenuCollection>;
  readonly order: Order;
  readonly orderLastPendingFeedback: Maybe<Order>;
  readonly orderPaymentState: Maybe<OrderPaymentState>;
  readonly orderStatus: Maybe<OrderStatusResponseUnion>;
  readonly orders: OrdersResponseUnion;
  readonly ordersV2: OrdersResponseUnion;
  readonly paymentMethodCards: ReadonlyArray<PaymentMethodCardUnion>;
  /** Returns a payment profile entry matching the customer customerId provided */
  readonly paymentProfile: Maybe<PaymentProfile>;
  /**
   * Returns a payment subscription profile matching the customer customerId provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly paymentSubscriptionProfile: Maybe<PaymentSubscriptionProfile>;
  /** Returns the point history for a user. */
  readonly pointHistoryForUser: PointHistoryForUserResponseUnion;
  readonly product: Product;
  readonly productForRestaurant: Maybe<Product>;
  readonly receipt: Maybe<ReceiptResponse>;
  readonly restaurant: Maybe<Restaurant>;
  readonly restaurantCapacity: RestaurantCapacity;
  /** Returns the entity ids of all restaurants that are not outposts. */
  readonly restaurantEntityIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Returns the restaurantID of entityIds with valid menus */
  readonly restaurantIdByEntityId: Maybe<Scalars['ID']['output']>;
  /** Find restaurants within a radius of given coordinates */
  readonly restaurantsByLocation: ReadonlyArray<Restaurant>;
  /** Find restaurants within a geographical bounding box */
  readonly restaurantsByRegion: ReadonlyArray<Restaurant>;
  /** Returns enabled, non-outpost restaurants accessible to an admin user based on their location permissions. Supports pagination and search. */
  readonly restaurantsForAdmin: ReadonlyArray<Restaurant>;
  readonly rewards: ReadonlyArray<Reward>;
  /** Returns all sweetgreen locations within topLeft and bottomRight map coordinates~ */
  readonly searchLocationsByBoundingBox: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /** Returns the sweetgreen location matching the entityId */
  readonly searchLocationsByEntityId: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /** Returns sweetgreen locations by string weighted by keyword match */
  readonly searchLocationsByString: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given kilometer radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInKilometerRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given kilometer radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInMeterRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /**
   * Returns all sweetgreen locations within a given mile radius, in ascending
   * order of proximity
   */
  readonly searchLocationsInMileRadius: Maybe<
    ReadonlyArray<Maybe<LocationSearchResult>>
  >;
  /** Search for restaurants by name */
  readonly searchRestaurants: ReadonlyArray<Restaurant>;
  readonly session: Session;
  /**
   * Returns a subscription plan matching the planId provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly subscriptionPlanById: Maybe<SubscriptionPlan>;
  /**
   * Returns an array of subscription plans matching the planIds provided
   * @deprecated Sunsetting sweetpass+ loyalty program
   */
  readonly subscriptionPlansByIds: Maybe<ReadonlyArray<SubscriptionPlan>>;
};

export type QueryAddressArgs = {
  addressId: Scalars['ID']['input'];
};

export type QueryAllLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryBaseProductArgs = {
  slug: Scalars['String']['input'];
};

export type QueryCanCancelArgs = {
  input: ReadonlyArray<CanCancelInput>;
};

export type QueryCanCancelV2Args = {
  input: ReadonlyArray<CanCancelInput>;
};

export type QueryCategoryUpsellsArgs = {
  restaurantId: Scalars['String']['input'];
};

export type QueryCateringOrdersArgs = {
  input: CateringOrdersInput;
};

export type QueryCustomerExistsArgs = {
  input: CustomerExistsInput;
};

export type QueryCustomerPointsForCustomerSupportArgs = {
  legacyInternalId: Scalars['ID']['input'];
};

export type QueryFavoritedLineItemsArgs = {
  input: FavoritedLineItemsInput;
};

export type QueryFeedbackQuestionsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryFetchPlansByTierIdArgs = {
  tierId: Scalars['ID']['input'];
};

export type QueryGetKioskPaymentsForCurrentDateArgs = {
  restaurantInfo: GetKioskPaymentsForCurrentDateInput;
};

export type QueryGetKioskReaderLocationIdArgs = {
  restaurantSlug: Scalars['String']['input'];
};

export type QueryGetKioskReaderLocationIdByEntityIdArgs = {
  restaurantEntityId: Scalars['String']['input'];
};

export type QueryGetKioskReaderLocationIdByRestaurantIdArgs = {
  restaurantId: Scalars['String']['input'];
};

export type QueryGetOrderPaymentStateArgs = {
  orderId: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
};

export type QueryGetSubscriptionsArgs = {
  status?: InputMaybe<ReadonlyArray<SubscriptionStatus>>;
};

export type QueryGiftCardOrderDetailArgs = {
  orderId: Scalars['String']['input'];
};

export type QueryGiftCardRedemptionDetailArgs = {
  id: Scalars['String']['input'];
};

export type QueryInStoreFeedbackQuestionsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryInStoreLoyaltyOrderArgs = {
  input: InStoreOrderInput;
};

export type QueryInStoreLoyaltyOrdersArgs = {
  input: InStoreOrdersInput;
};

export type QueryKioskCustomerProfileArgs = {
  customerToken?: InputMaybe<Scalars['String']['input']>;
  loyaltyID?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryKioskCustomerScanPaymentInfoArgs = {
  customerToken: Scalars['String']['input'];
};

export type QueryLineItemArgs = {
  input: LineItemInput;
};

export type QueryLineItemBySlugArgs = {
  input: LineItemBySlugInput;
};

export type QueryLocationByAddressArgs = {
  input: LocationByAddressInput;
};

export type QueryLocationByAddressIdArgs = {
  input: LocationByAddressIdInput;
};

export type QueryLocationByAddressV2Args = {
  input: LocationByAddressV2Input;
};

export type QueryLoyaltyProfileByLoyaltyIdArgs = {
  loyaltyId: Scalars['ID']['input'];
};

export type QueryLoyaltyProfileWithLoyaltyArgs = {
  customerToken: Scalars['String']['input'];
};

export type QueryMenuCollectionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMenuCollectionsArgs = {
  menuId: Scalars['ID']['input'];
};

export type QueryOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryOrderPaymentStateArgs = {
  orderId: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
};

export type QueryOrderStatusArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryOrdersArgs = {
  input: OrdersInput;
};

export type QueryOrdersV2Args = {
  input: OrdersInputV2;
};

export type QueryPointHistoryForUserArgs = {
  page: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryProductForRestaurantArgs = {
  baseProductSlug: Scalars['String']['input'];
  restaurantId: Scalars['String']['input'];
};

export type QueryReceiptArgs = {
  id: Scalars['String']['input'];
};

export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRestaurantCapacityArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  minimumLineItemCapacity?: InputMaybe<Scalars['Int']['input']>;
  restaurantId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRestaurantIdByEntityIdArgs = {
  entityId: Scalars['ID']['input'];
};

export type QueryRestaurantsByLocationArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius?: Scalars['Float']['input'];
  type?: RestaurantSearchType;
};

export type QueryRestaurantsByRegionArgs = {
  bottomRightLat: Scalars['Float']['input'];
  bottomRightLng: Scalars['Float']['input'];
  sortByLat?: InputMaybe<Scalars['Float']['input']>;
  sortByLng?: InputMaybe<Scalars['Float']['input']>;
  topLeftLat: Scalars['Float']['input'];
  topLeftLng: Scalars['Float']['input'];
  type?: RestaurantSearchType;
};

export type QueryRestaurantsForAdminArgs = {
  input?: InputMaybe<RestaurantsForAdminInput>;
};

export type QuerySearchLocationsByBoundingBoxArgs = {
  bottomRight: GeoCoordinates;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  topLeft: GeoCoordinates;
};

export type QuerySearchLocationsByEntityIdArgs = {
  entityId: Scalars['String']['input'];
};

export type QuerySearchLocationsByStringArgs = {
  searchString: Scalars['String']['input'];
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchLocationsInKilometerRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchLocationsInMeterRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchLocationsInMileRadiusArgs = {
  latLong: GeoCoordinates;
  radius?: InputMaybe<Scalars['Float']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchRestaurantsArgs = {
  query: Scalars['String']['input'];
  type?: RestaurantSearchType;
};

export type QuerySubscriptionPlanByIdArgs = {
  planId: Scalars['ID']['input'];
};

export type QuerySubscriptionPlansByIdsArgs = {
  planIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type Receipt = {
  readonly __typename?: 'Receipt';
  readonly id: Scalars['ID']['output'];
  readonly isClaimed: Scalars['Boolean']['output'];
  readonly order: Order;
  readonly restaurant: Restaurant;
};

export type ReceiptAlreadyClaimed = UserError & {
  readonly __typename?: 'ReceiptAlreadyClaimed';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type ReceiptAlreadyClaimedError = UserError & {
  readonly __typename?: 'ReceiptAlreadyClaimedError';
  readonly errorMessage: Scalars['String']['output'];
};

export type ReceiptNotFound = UserError & {
  readonly __typename?: 'ReceiptNotFound';
  readonly errorMessage: Scalars['String']['output'];
};

export type ReceiptResponse =
  | ExpiredReceipt
  | Receipt
  | ReceiptAlreadyClaimed
  | ReceiptNotFound;

export enum RecommendationType {
  Historical = 'HISTORICAL',
  New = 'NEW',
}

export type RedeemGiftCardResponseUnion =
  | GiftCardAssociatedWithAnotherAccountError
  | GiftCardBalance
  | InvalidGiftCardError
  | NoBalanceGiftCardError
  | UnableToRedeemGiftCardError;

/** InStore = Reward can be redeemed in store, Delivery = Reward can be redeemed in delivery, Pickup = Reward can be redeemed in pickup, All = Reward can be redeemed in all channels */
export enum RedemptionChannel {
  All = 'All',
  Delivery = 'Delivery',
  InStore = 'InStore',
  Outpost = 'Outpost',
  Pickup = 'Pickup',
}

/** Kiosk refund response */
export type RefundKioskPaymentResponse = {
  readonly __typename?: 'RefundKioskPaymentResponse';
  readonly failureReason: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type RefundKioskPaymentResponseUnion =
  | FailedToFetchPaymentIntent
  | ForbiddenError
  | InvalidRefundAmount
  | PaymentAlreadyRefunded
  | RefundKioskPaymentResponse
  | StripeRefundErrorResponse;

export type RefundOrderInput = {
  /** Person making the adjustment to the order payment. */
  readonly adjuster: Scalars['String']['input'];
  /** Array of Gravy IDs to be refunded. */
  readonly order_ids: ReadonlyArray<Scalars['String']['input']>;
  /** Callers origin (eg kustomer, customer, etc.). */
  readonly origin: Scalars['String']['input'];
  /** Description for why the order is being refunded. */
  readonly reason: Scalars['String']['input'];
};

export type RefundOrderSuccess = {
  readonly __typename?: 'RefundOrderSuccess';
  /** Array of refund results for each refunded order. */
  readonly refundResults: ReadonlyArray<RefundResult>;
};

export type RefundResult = {
  readonly __typename?: 'RefundResult';
  /** Gravy order ID being refunded. */
  readonly id: Scalars['String']['output'];
  /** Reason for a failed order or a success string. */
  readonly reason: Scalars['String']['output'];
  /** Boolean representing if the order successfully refunded or not. */
  readonly success: Scalars['Boolean']['output'];
};

export type RegisterGuestFailed = {
  readonly __typename?: 'RegisterGuestFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RegisterGuestInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterGuestResponseUnion =
  | RegisterGuestFailed
  | RegisterGuestSuccess
  | ValidationError;

export type RegisterGuestSuccess = {
  readonly __typename?: 'RegisterGuestSuccess';
  readonly csrf: Scalars['String']['output'];
  /** Guest details. */
  readonly guest: Guest;
};

export type RemoveFromCartInput = {
  readonly lineItemId: Scalars['ID']['input'];
};

export type RemoveFromCartResponseUnion =
  | LocationClosed
  | RemoveFromCartSuccess
  | ValidationError;

export type RemoveFromCartSuccess = {
  readonly __typename?: 'RemoveFromCartSuccess';
  readonly cart: Order;
  readonly success: Scalars['Boolean']['output'];
};

export type RemoveFromCartWithLoyaltyInput = {
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly lineItemId: Scalars['ID']['input'];
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveRewardByLoyaltyIdInput = {
  /** The loyalty ID of the customer. */
  readonly loyaltyId: Scalars['ID']['input'];
};

export type RemoveRewardInput = {
  /** The ID of the order the reward is being removed from */
  readonly orderId: Scalars['ID']['input'];
};

export type RemoveRewardResponseUnion =
  | RemoveRewardSuccess
  | RewardNotRemoved
  | ValidationError;

export type RemoveRewardSuccess = {
  readonly __typename?: 'RemoveRewardSuccess';
  readonly order: Order;
};

export type RemoveRewardWithLoyaltyInput = {
  /** The customer token of the customer. */
  readonly customerToken: Scalars['String']['input'];
};

export type ReorderConflict = {
  readonly __typename?: 'ReorderConflict';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  /** Indicates if all products in the order are unavailable */
  readonly isNothingAvailable: Scalars['Boolean']['output'];
};

export type ReorderInput = {
  readonly deliveryOrderDetails?: InputMaybe<DeliveryOrderDetailInput>;
  readonly destinationRestaurantId: Scalars['ID']['input'];
  readonly id: Scalars['ID']['input'];
  /** Ignore order conflicts and submit reorder */
  readonly ignoreConflicts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReorderResponseUnion =
  | CanNotReorder
  | ReorderConflict
  | ReorderSuccess
  | RestaurantMaxDeliveryQuantityExceeded
  | RestaurantMaxQuantityExceeded
  | ValidationError;

export type ReorderSuccess = {
  readonly __typename?: 'ReorderSuccess';
  readonly cart: Order;
  /** Indicates if the reorder supports mixing */
  readonly isMixingSupported: Scalars['Boolean']['output'];
};

export type RequestAccountDeletionFailed = {
  readonly __typename?: 'RequestAccountDeletionFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RequestAccountDeletionResponseUnion =
  | RequestAccountDeletionFailed
  | RequestAccountDeletionSuccess;

export type RequestAccountDeletionSuccess = {
  readonly __typename?: 'RequestAccountDeletionSuccess';
  readonly success: Scalars['Boolean']['output'];
};

export type Restaurant = {
  readonly __typename?: 'Restaurant';
  readonly address: Scalars['String']['output'];
  readonly asset: Asset;
  /** Some outposts have multiple shelves within them (say, on different floors), and allow customers to select one */
  readonly availableDropOffLocations: ReadonlyArray<DropOffLocation>;
  readonly city: Scalars['String']['output'];
  readonly deliveryFee: Scalars['Int']['output'];
  readonly deliveryMinSubtotal: Scalars['Float']['output'];
  readonly entityId: Maybe<Scalars['Int']['output']>;
  readonly flexMessage: Maybe<Scalars['String']['output']>;
  readonly hours: RestaurantHours;
  readonly id: Scalars['ID']['output'];
  readonly isAcceptingOrders: Scalars['Boolean']['output'];
  readonly isOutpost: Scalars['Boolean']['output'];
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly mdmId: Maybe<Scalars['String']['output']>;
  readonly menu: Menu;
  readonly name: Scalars['String']['output'];
  readonly notAcceptingOrdersReason: Scalars['String']['output'];
  readonly parentId: Maybe<Scalars['Int']['output']>;
  readonly phone: Scalars['String']['output'];
  readonly sanitaryGradeDisplayText: Maybe<Scalars['String']['output']>;
  readonly sanitaryGradeUrl: Maybe<Scalars['String']['output']>;
  readonly showDeliveryFeeDisclosure: Scalars['Boolean']['output'];
  readonly showDeliveryPriceDifferenciationDisclosure: Scalars['Boolean']['output'];
  readonly showOutpostPriceDifferenciationDisclosure: Scalars['Boolean']['output'];
  readonly showWarningDialog: Maybe<Scalars['Boolean']['output']>;
  readonly slug: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly utcOffset: Maybe<Scalars['Int']['output']>;
  readonly warningDialogDescription: Maybe<Scalars['String']['output']>;
  readonly warningDialogTimeout: Maybe<Scalars['Int']['output']>;
  readonly warningDialogTitle: Maybe<Scalars['String']['output']>;
  readonly zipCode: Scalars['String']['output'];
};

export type RestaurantCapacity = {
  readonly __typename?: 'RestaurantCapacity';
  /** available capacity slots */
  readonly availableWantedTimes: ReadonlyArray<RestaurantCapacitySlot>;
  readonly restaurantAddress: Scalars['String']['output'];
  readonly restaurantHours: Scalars['String']['output'];
  readonly restaurantId: Scalars['ID']['output'];
};

export type RestaurantCapacitySlot = {
  readonly __typename?: 'RestaurantCapacitySlot';
  readonly availableLineItems: Scalars['Float']['output'];
  /** A timeslot in Day, HH:MM format using timezone of the store's location */
  readonly formatted: Scalars['String']['output'];
  readonly maxLineItems: Scalars['Float']['output'];
  /** A timeslot in ISO8601 date time format using timezone of the store's location */
  readonly original: Scalars['String']['output'];
};

export type RestaurantHours = {
  readonly __typename?: 'RestaurantHours';
  readonly formatted: Maybe<Scalars['String']['output']>;
  readonly permanent: ReadonlyArray<RestaurantStoreHours>;
  readonly store: ReadonlyArray<RestaurantStoreHours>;
};

/** Deprecated: This is deprecated in favor of LocationClosed. This is still kept around for some old native apps out in the wild. */
export type RestaurantHoursMissing = UserError & {
  readonly __typename?: 'RestaurantHoursMissing';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantIsNotAcceptingOrders = UserError & {
  readonly __typename?: 'RestaurantIsNotAcceptingOrders';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantLocationInfoInputDto = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly display_name: Scalars['String']['input'];
  readonly line1: Scalars['String']['input'];
  readonly line2?: InputMaybe<Scalars['String']['input']>;
  readonly postal_code: Scalars['String']['input'];
  readonly restaurant_entity_id?: InputMaybe<Scalars['String']['input']>;
  readonly restaurant_slug: Scalars['String']['input'];
  readonly state: Scalars['String']['input'];
};

export type RestaurantLocationInfoWithIdsInput = {
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly displayName: Scalars['String']['input'];
  readonly line1: Scalars['String']['input'];
  readonly line2?: InputMaybe<Scalars['String']['input']>;
  readonly postalCode: Scalars['String']['input'];
  readonly restaurantEntityId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantId?: InputMaybe<Scalars['String']['input']>;
  readonly restaurantSlug?: InputMaybe<Scalars['String']['input']>;
  readonly state: Scalars['String']['input'];
};

export type RestaurantMaxDeliveryQuantityExceeded = {
  readonly __typename?: 'RestaurantMaxDeliveryQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RestaurantMaxQuantityExceeded = {
  readonly __typename?: 'RestaurantMaxQuantityExceeded';
  readonly conflicts: ReadonlyArray<OrderConflict>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** Type of restaurant to search for */
export enum RestaurantSearchType {
  /** Search all restaurants and outposts */
  All = 'ALL',
  /** Search only outposts (restaurants with parent_id) */
  Outpost = 'OUTPOST',
  /** Search only regular restaurants (no parent_id) */
  Restaurant = 'RESTAURANT',
}

export type RestaurantStoreHours = {
  readonly __typename?: 'RestaurantStoreHours';
  /** Day of the week */
  readonly day: Scalars['String']['output'];
  /** Time formatted as hh:mm (ex. 10:00). Will show as "CLOSED" if the store is closed for the day */
  readonly end: Scalars['String']['output'];
  /** Time formatted as hh:mm (ex. 10:00). Will show as "CLOSED" if the store is closed for the day */
  readonly start: Scalars['String']['output'];
};

export type RestaurantsForAdminInput = {
  /** Maximum number of restaurants to return (max: 50) */
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of restaurants to skip for pagination */
  readonly offset?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive search term for restaurant name (minimum 2 characters) */
  readonly search?: InputMaybe<Scalars['String']['input']>;
};

/** Entity contributes to the Rewards entity in Monograph with fields provided by Challenges SVC */
export type Reward = {
  readonly __typename?: 'Reward';
  /** URL for the reward image */
  readonly assetUrl: Maybe<Scalars['String']['output']>;
  /** Date the reward expires */
  readonly expirationDate: Maybe<Scalars['String']['output']>;
  /** SessionM Offer ID - Not direct match to ID in Reward entity in Monograph but included in the serialized value */
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  /** If true, reward can be used and UI should allow it to be selected on the bag */
  readonly redeemable: Scalars['Boolean']['output'];
  /** If redeemable is false, this will populate with the next timestamp in UTC when the offer can be used. */
  readonly redeemableAt: Maybe<Scalars['DateTime']['output']>;
  /** The channel(s) in which the reward can be redeemed */
  readonly redemptionChannel: RedemptionChannel;
  readonly rewardType: RewardType;
  /** Field references the offer terms and conditions configured in SessionM. If that field is not configured, returns the default SG terms url. */
  readonly terms: Scalars['String']['output'];
};

/** Indicates that adding, removing, or validating a reward failed and that an error should be shown to the customer. The end result is always that the cart's current reward is cleared; clients should update their internal state to reflect this. */
export type RewardNotApplied = {
  readonly __typename?: 'RewardNotApplied';
  /**
   * Provides more detail about the reason reward application failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value.
   * @deprecated Use failureReasons and failureMetadata instead
   */
  readonly failureCode: ApplyRewardFailureCode;
  /** Provides even more detail about the reason reward application failed. Clients use these for more refined messaging. */
  readonly failureMetadata: ApplyRewardFailureMetadata;
  /** Provides more detail about the reason reward application failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureReasons: ReadonlyArray<Scalars['String']['output']>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RewardNotRemoved = {
  readonly __typename?: 'RewardNotRemoved';
  /** Provides more detail about the reason reward removal failed. Clients should map these to customer-facing error messages, with a generic default for an unrecognized value. */
  readonly failureCode: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type RewardNotValidated = UserError & {
  readonly __typename?: 'RewardNotValidated';
  readonly errorMessage: Scalars['String']['output'];
  readonly failureCode: ValidateRewardFailureCode;
  readonly failureMetadata: Maybe<ValidateRewardFailureMetadata>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export enum RewardType {
  NonPremium = 'NON_PREMIUM',
  Premium = 'PREMIUM',
}

/** Validation error response */
export type RewardValidationGeneralError = {
  readonly __typename?: 'RewardValidationGeneralError';
  readonly errorMessage: Scalars['String']['output'];
};

export type RewardsPremiumStatus = {
  readonly __typename?: 'RewardsPremiumStatus';
  readonly expirationDate: Scalars['String']['output'];
  readonly isActive: Scalars['Boolean']['output'];
};

export type RewardsValidateAndPreviewUnion = RewardValidationGeneralError;

export type RewardsValidateAndReserveUnion = RewardValidationGeneralError;

export type SelectedRewardsWithDetails = {
  readonly id: Scalars['String']['input'];
  readonly offerId?: InputMaybe<Scalars['String']['input']>;
};

export type Session = {
  readonly __typename?: 'Session';
  readonly cart: Maybe<Order>;
  readonly csrf: Scalars['String']['output'];
  /** ID of the order currently in-flight, restricted to delivery orders. */
  readonly inFlightDeliveryOrderId: Maybe<Scalars['ID']['output']>;
  /** ID of the order currently in-flight. */
  readonly inFlightOrderId: Maybe<Scalars['ID']['output']>;
  readonly isLoggedIn: Scalars['Boolean']['output'];
};

export type SignInFailed = {
  readonly __typename?: 'SignInFailed';
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type SignInResponseUnion =
  | CustomerNotFound
  | SignInFailed
  | SignInSuccess
  | ValidationError;

export type SignInSuccess = {
  readonly __typename?: 'SignInSuccess';
  readonly customer: Customer;
};

/** Reduced version of Restaurant, with fields required for location search. */
export type StoreLocation = {
  readonly __typename?: 'StoreLocation';
  readonly acceptingOrders: Scalars['Boolean']['output'];
  readonly address: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly comingSoon: Maybe<Scalars['Boolean']['output']>;
  readonly crossStreet: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly entityId: Maybe<Scalars['ID']['output']>;
  readonly flexMessage: Maybe<Scalars['String']['output']>;
  readonly hidden: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Scalars['String']['output'];
  readonly isOutpost: Maybe<Scalars['Boolean']['output']>;
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
  readonly menuId: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly nativeDeliveryPriceDifferentiationEnabled: Maybe<
    Scalars['Boolean']['output']
  >;
  readonly notAcceptingOrdersReason: Maybe<Scalars['String']['output']>;
  readonly oloId: Scalars['ID']['output'];
  readonly outpostPriceDifferentiationEnabled: Maybe<
    Scalars['Boolean']['output']
  >;
  readonly phone: Maybe<Scalars['String']['output']>;
  readonly pickupInstructions: Maybe<Scalars['String']['output']>;
  readonly regionId: Maybe<Scalars['ID']['output']>;
  readonly sanitaryGradeDisplayText: Maybe<Scalars['String']['output']>;
  readonly sanitaryGradeUrl: Maybe<Scalars['String']['output']>;
  readonly showWarningDialog: Scalars['Boolean']['output'];
  readonly slug: Scalars['String']['output'];
  readonly state: Scalars['String']['output'];
  readonly status: Maybe<Scalars['String']['output']>;
  readonly storeHours: Maybe<Scalars['String']['output']>;
  readonly warningDialogDescription: Maybe<Scalars['String']['output']>;
  readonly warningDialogTimeout: Maybe<Scalars['Float']['output']>;
  readonly warningDialogTitle: Maybe<Scalars['String']['output']>;
  readonly zipCode: Scalars['String']['output'];
};

export type StoreOffline = UserError & {
  readonly __typename?: 'StoreOffline';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type StripeRefundErrorResponse = UserError & {
  readonly __typename?: 'StripeRefundErrorResponse';
  readonly errorMessage: Scalars['String']['output'];
};

export type SubmitGiftCardCodeSuccess = {
  readonly __typename?: 'SubmitGiftCardCodeSuccess';
  /** Total credit after applying gift card */
  readonly totalCredit: Scalars['Float']['output'];
};

/** "Unable to purchase gift card" user error */
export type SubmitGiftCardOrderError = UserError & {
  readonly __typename?: 'SubmitGiftCardOrderError';
  readonly errorMessage: Scalars['String']['output'];
};

export type SubmitGiftCardOrderUsingPaymentMethodInput = {
  readonly assetId: Scalars['String']['input'];
  readonly balance: Scalars['Float']['input'];
  readonly deliveryDateTime?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryMethods: ReadonlyArray<Scalars['String']['input']>;
  readonly isAsap: Scalars['Boolean']['input'];
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly paymentMethodId: Scalars['String']['input'];
  readonly quantity: Scalars['Float']['input'];
  readonly recipientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly recipientName: Scalars['String']['input'];
  readonly senderName: Scalars['String']['input'];
  readonly utcOffset: Scalars['Float']['input'];
};

export type SubmitGiftCardOrderUsingPaymentMethodResponseUnion =
  | GiftCardOrderDetail
  | SubmitGiftCardOrderError;

export type SubmitOrderAsapInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitOrderAsapWithLoyaltyInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  /**  The customer's scanned loyalty token */
  readonly customerToken?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly loyaltyId?: InputMaybe<Scalars['String']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly paymentId?: InputMaybe<Scalars['String']['input']>;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitOrderInput = {
  /** If the client has their own identifier for this order, they should provide it here for potential correlation on sweetgreen's end. For example, delivery marketplaces should provide their order id. */
  readonly externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: OrderType;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderUsingBillingAccountResponseUnion =
  | DeliveryAlreadyInFlight
  | DeliverySpecifyAddress
  | InvalidBillingAccount
  | InvalidCustomerPhone
  | InvalidTip
  | MinimumDeliverySubtotalNotMet
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderUsingBillingAccountSuccess
  | SubmitOrderUsingPaymentMethodCardSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderUsingBillingAccountSuccess = {
  readonly __typename?: 'SubmitOrderUsingBillingAccountSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderUsingPaymentIntentInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: InputMaybe<Scalars['ID']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** Already confirmed payment intent id */
  readonly paymentIntentId: Scalars['ID']['input'];
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: Scalars['Boolean']['input'];
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderUsingPaymentIntentResponseUnion =
  | DeclinedPaymentMethod
  | DeliveryAlreadyInFlight
  | DeliverySpecifyAddress
  | IncorrectPaymentMethod
  | InvalidCustomerPhone
  | InvalidTip
  | MinimumDeliverySubtotalNotMet
  | ProductOutOfStock
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderUsingPaymentIntentSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderUsingPaymentIntentSuccess = {
  readonly __typename?: 'SubmitOrderUsingPaymentIntentSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderUsingPaymentMethodCardInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: InputMaybe<Scalars['ID']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** Customer's saved Payment Method card */
  readonly paymentMethodCardId: Scalars['ID']['input'];
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  readonly shouldTrackPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: Scalars['Boolean']['input'];
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderUsingPaymentMethodCardSuccess = {
  readonly __typename?: 'SubmitOrderUsingPaymentMethodCardSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderUsingPaymentMethodInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly deliveryOrderDetail?: InputMaybe<DeliveryOrderDetailInput>;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: InputMaybe<Scalars['ID']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notificationType?: InputMaybe<NotificationType>;
  readonly orderId: Scalars['ID']['input'];
  /** Customer's saved Payment Method */
  readonly paymentMethodId: Scalars['ID']['input'];
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  readonly shouldTrackPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: Scalars['Boolean']['input'];
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderUsingPaymentMethodResponseUnion =
  | DeclinedPaymentMethod
  | DeliveryAlreadyInFlight
  | DeliverySpecifyAddress
  | IncorrectPaymentMethod
  | InvalidCustomerPhone
  | InvalidTip
  | MinimumDeliverySubtotalNotMet
  | ProductOutOfStock
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderUsingPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderUsingPaymentMethodSuccess = {
  readonly __typename?: 'SubmitOrderUsingPaymentMethodSuccess';
  readonly customer: Customer;
  readonly order: Order;
};

export type SubmitOrderWithPaymentMethodInput = {
  /** If the client has their own identifier for this order, they should provide it here for potential correlation on sweetgreen's end. For example, delivery marketplaces should provide their order id. */
  readonly externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  readonly includeUtensils?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderId: Scalars['ID']['input'];
  /** the order type to be submitted, ie: pickup */
  readonly orderType: Scalars['String']['input'];
  /** the order payment method, ie: prepaid or cash */
  readonly paymentMethod: PaymentMethods;
  readonly pickupTip?: InputMaybe<Scalars['Float']['input']>;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: Scalars['String']['input'];
};

export type SubmitOrderWithPaymentMethodResponseUnion =
  | DeclinedPaymentMethod
  | InvalidBillingAccount
  | InvalidCreditCard
  | LoyaltyScanPaymentTokenInvalid
  | LoyaltyScanTokenExpired
  | MinimumDeliverySubtotalNotMet
  | ProductUnavailable
  | RestaurantIsNotAcceptingOrders
  | RewardNotValidated
  | StoreOffline
  | SubmitOrderWithPaymentMethodSuccess
  | TimeslotUnavailable
  | ValidationError;

export type SubmitOrderWithPaymentMethodSuccess = {
  readonly __typename?: 'SubmitOrderWithPaymentMethodSuccess';
  readonly order: Order;
};

export type SubmitPromoCodeInput = {
  /** Promotion code */
  readonly code: Scalars['String']['input'];
};

export type SubmitPromoCodeOrGiftCardResponseUnion =
  | InvalidPromoCode
  | PromoCodeAlreadyApplied
  | SubmitGiftCardCodeSuccess
  | SubmitPromoCodeSuccessV2
  | ValidationError;

export type SubmitPromoCodeResponseUnion =
  | InvalidPromoCode
  | PromoCodeAlreadyApplied
  | SubmitPromoCodeSuccessV2
  | ValidationError;

export type SubmitPromoCodeSuccessV2 = {
  readonly __typename?: 'SubmitPromoCodeSuccessV2';
  /** Placeholder value that always returns true. Use `__typename` to identify success */
  readonly placeholder: Scalars['Boolean']['output'];
};

export type SubmitPromoOrGiftCardCodeInput = {
  /** Promotion or gift card code */
  readonly code: Scalars['String']['input'];
};

export type SubscriptionCreditCard = {
  readonly __typename?: 'SubscriptionCreditCard';
  readonly cardType: BraintreeCardType;
  readonly expirationMonth: Maybe<Scalars['String']['output']>;
  readonly expirationState: CardExpirationState;
  readonly expirationYear: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly lastFour: Scalars['String']['output'];
};

/** Customer Subscription Plan (deprecated) */
export type SubscriptionPlan = {
  readonly __typename?: 'SubscriptionPlan';
  /** The value that specifies the day of the month that the Braintree gateway will charge the subscription each billing cycle */
  readonly billingDayOfMonth: Maybe<Scalars['String']['output']>;
  /** Specifies the billing interval of the plan in months */
  readonly billingFrequency: Scalars['String']['output'];
  /**
   * The frequency in which subscription payments should be made.
   * @deprecated Deprecated in favor of `billingRecurrence`
   */
  readonly billingFrequencyUnit: Maybe<DurationUnit>;
  /** The recurrence in which subscription payments should be made. */
  readonly billingRecurrence: Maybe<DurationUnit>;
  /** The date/time the plan was created in UTC format */
  readonly createdAt: Scalars['String']['output'];
  /** The currency for the transaction */
  readonly currencyIsoCode: Scalars['String']['output'];
  /** The description of the plan */
  readonly description: Maybe<Scalars['String']['output']>;
  /** The plan identifier */
  readonly discounts: Maybe<ReadonlyArray<Discount>>;
  /** Whether this plan supports a free trial */
  readonly hasFreeTrial: Scalars['Boolean']['output'];
  /** The plan identifier */
  readonly id: Scalars['String']['output'];
  /** The name of the plan */
  readonly name: Scalars['String']['output'];
  /** The base price for the plan */
  readonly price: Scalars['String']['output'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  PastDue = 'PAST_DUE',
  Pending = 'PENDING',
}

export type SubscriptionTransactions = {
  readonly __typename?: 'SubscriptionTransactions';
  readonly amount: Scalars['String']['output'];
  readonly creditCard: SubscriptionCreditCard;
  readonly date: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly refund: Scalars['Boolean']['output'];
  readonly transactionCreditCard: TransactionCreditCard;
};

export type SyncChanges = {
  readonly __typename?: 'SyncChanges';
  /** Fields added on initial insert (empty for updates) */
  readonly additions: ReadonlyArray<Scalars['String']['output']>;
  /** Fields removed during sync (with before values) */
  readonly deletions: ReadonlyArray<ChangeDetail>;
  /** Fields updated during sync with before/after values */
  readonly updates: ReadonlyArray<ChangeDetail>;
};

export type SyncLocationInput = {
  /** When true, includes the raw Salesforce payload in the response for debugging. */
  readonly isDebug?: Scalars['Boolean']['input'];
  /** When true, performs a dry-run and returns the computed changes without persisting to the database. */
  readonly isPreview?: Scalars['Boolean']['input'];
  readonly salesforceId: Scalars['String']['input'];
};

export type SyncLocationResult = {
  readonly __typename?: 'SyncLocationResult';
  /** Detailed change information. For preview mode, this reflects what would change. */
  readonly changes: Maybe<SyncChanges>;
  /** Results of child outpost syncs triggered when parent restaurant Outpost_Price_Differentiation changes */
  readonly childSyncResults: Maybe<ReadonlyArray<ChildSyncResult>>;
  /** Raw Salesforce payload for debugging (only set when isDebug=true) */
  readonly data: Maybe<Scalars['JSON']['output']>;
  /** Array of error messages (only present when success is false) */
  readonly errors: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** When true, the sync ran in preview mode (no database writes were performed). */
  readonly isPreview: Scalars['Boolean']['output'];
  /** The Salesforce Account ID that was queried */
  readonly salesforceId: Scalars['String']['output'];
  /** Indicates whether the sync operation succeeded */
  readonly success: Scalars['Boolean']['output'];
  /** Timestamp when the sync was performed (null on failure) */
  readonly syncedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Loyalty Tier */
export type Tier = {
  readonly __typename?: 'Tier';
  /** Loyalty Tier Display Name */
  readonly displayName: Scalars['String']['output'];
  /** Tier ID */
  readonly id: Scalars['ID']['output'];
  /** Loyalty Tier Name */
  readonly name: TierName;
  /** Loyalty Tier Name */
  readonly nameV2: TierName;
  /** Next tier */
  readonly nextTier: Maybe<Tier>;
  /** Tier Group */
  readonly tierGroup: TierGroup;
};

/** Tier Group */
export type TierGroup = {
  readonly __typename?: 'TierGroup';
  /** Tier Group ID */
  readonly id: Scalars['ID']['output'];
  /** Tier Group Name */
  readonly name: Scalars['ID']['output'];
};

export enum TierName {
  OptedOut = 'OPTED_OUT',
  RewardsBase = 'REWARDS_BASE',
  RewardsOptedOut = 'REWARDS_OPTED_OUT',
  Sweetpass = 'SWEETPASS',
  SweetpassPlus = 'SWEETPASS_PLUS',
}

/** Loyalty Tier */
export type TierStatus = {
  readonly __typename?: 'TierStatus';
  /** Tier ID */
  readonly id: Scalars['ID']['output'];
  /** Tier Status Name */
  readonly name: TierStatusName;
};

export enum TierStatusName {
  Active = 'ACTIVE',
  CancellationPending = 'CANCELLATION_PENDING',
  FreeTrial = 'FREE_TRIAL',
  PastDue = 'PAST_DUE',
  Processing = 'PROCESSING',
}

export type TimeRestrictionError = UserError & {
  readonly __typename?: 'TimeRestrictionError';
  readonly errorMessage: Scalars['String']['output'];
};

export type TimeslotUnavailable = UserError & {
  readonly __typename?: 'TimeslotUnavailable';
  readonly errorMessage: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type TransactionCreditCard = {
  readonly __typename?: 'TransactionCreditCard';
  readonly cardType: BraintreeCardType;
  /** Credit card ID, if the Credit Card was removed Transaction ID */
  readonly id: Scalars['ID']['output'];
  readonly lastFour: Scalars['String']['output'];
};

export type TransactionNotFoundError = UserError & {
  readonly __typename?: 'TransactionNotFoundError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Trial Eligibility */
export type TrialEligibility = {
  readonly __typename?: 'TrialEligibility';
  /** The trial duration length */
  readonly duration: Scalars['Int']['output'];
  /** The trial duration unit */
  readonly durationUnit: DurationUnit;
};

/** "Unable to get gift card balance" user error */
export type UnableToGetGiftCardBalanceError = UserError & {
  readonly __typename?: 'UnableToGetGiftCardBalanceError';
  readonly errorMessage: Scalars['String']['output'];
};

/** "Unable to redeem gift card" user error */
export type UnableToRedeemGiftCardError = UserError & {
  readonly __typename?: 'UnableToRedeemGiftCardError';
  readonly errorMessage: Scalars['String']['output'];
};

/** Generic user error */
export type UnknownUserError = UserError & {
  readonly __typename?: 'UnknownUserError';
  readonly errorMessage: Scalars['String']['output'];
};

export type UpdateAddressResponseUnion =
  | InvalidAddress
  | UpdateAddressSuccess
  | ValidationError;

export type UpdateAddressSuccess = {
  readonly __typename?: 'UpdateAddressSuccess';
  readonly address: Address;
};

export type UpdateCustomerInput = {
  readonly birthday?: InputMaybe<Scalars['String']['input']>;
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerPreferencesError = UserError & {
  readonly __typename?: 'UpdateCustomerPreferencesError';
  readonly errorMessage: Scalars['String']['output'];
};

export type UpdateCustomerPreferencesUnion =
  | CustomerPreference
  | UpdateCustomerPreferencesError;

export type UpdateCustomerResponse = {
  readonly __typename?: 'UpdateCustomerResponse';
  readonly customer: Customer;
};

export type UpdateKioskCustomerInput = {
  readonly contactNumber?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKioskCustomerResponse = {
  readonly __typename?: 'UpdateKioskCustomerResponse';
  readonly customer: Customer;
};

export type UpdatePaymentMethodInput = {
  /** Id of card to update */
  readonly id: Scalars['String']['input'];
  /** New default flag value of card to update */
  readonly isDefault: Scalars['Boolean']['input'];
  /** New nickname of card to update */
  readonly nickname: Scalars['String']['input'];
};

export type UpdateUseCreditResponse = {
  readonly __typename?: 'UpdateUseCreditResponse';
  readonly customer: Customer;
};

export type UpsellCategory = {
  readonly __typename?: 'UpsellCategory';
  readonly categoryRanking: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly products: ReadonlyArray<UpsellCategoryProduct>;
  readonly restaurantId: Scalars['String']['output'];
};

export type UpsellCategoryProduct = {
  readonly __typename?: 'UpsellCategoryProduct';
  /** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
  readonly channelCost: Scalars['Int']['output'];
  readonly cost: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Scalars['String']['output'];
  readonly menuId: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly outOfStock: Scalars['Boolean']['output'];
};

export type UpsellCategoryProductChannelCostArgs = {
  costChannel?: InputMaybe<CostChannel>;
};

export type UserError = {
  readonly errorMessage: Scalars['String']['output'];
};

/** The purchased gift card details */
export type UserGiftCard = {
  readonly __typename?: 'UserGiftCard';
  /** Gift card asset id. */
  readonly assetId: Maybe<Scalars['String']['output']>;
  /** Gift card balance. */
  readonly balance: Scalars['Float']['output'];
  /** Gift card id. */
  readonly id: Scalars['String']['output'];
  /** User provided message sent to the gift card recipient. */
  readonly message: Maybe<Scalars['String']['output']>;
  /** User provided email of the gift card recipient. */
  readonly recipientEmail: Maybe<Scalars['String']['output']>;
  /** User provided name of the gift card recipient. */
  readonly recipientName: Scalars['String']['output'];
  /** Gift card redemption token. */
  readonly redemptionToken: Maybe<Scalars['String']['output']>;
};

/** User Notification Preferences */
export type UserNotificationPreferences = {
  readonly __typename?: 'UserNotificationPreferences';
  readonly notificationCategories: ReadonlyArray<NotificationCategory>;
};

export type UserNotificationPreferencesUnion =
  | NotificationPreferencesError
  | UserNotificationPreferences;

export type UserPointsStatus = {
  readonly __typename?: 'UserPointsStatus';
  readonly available: Scalars['Float']['output'];
  readonly pending: Scalars['Float']['output'];
  readonly total: Scalars['Float']['output'];
};

export type ValidateAndRefreshGiftCardRedemptionTokenForCustomerInput = {
  readonly recipientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly redemptionToken: Scalars['String']['input'];
};

export type ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse = {
  readonly __typename?: 'ValidateAndRefreshGiftCardRedemptionTokenForCustomerResponse';
  /** A valid redemption token generated with the new secret. */
  readonly redemptionToken: Maybe<Scalars['String']['output']>;
  /** Whether the redemption token is valid. */
  readonly valid: Scalars['Boolean']['output'];
};

export enum ValidateRewardFailureCode {
  CartNotFound = 'CART_NOT_FOUND',
  ChannelRestriction = 'CHANNEL_RESTRICTION',
  DayRestriction = 'DAY_RESTRICTION',
  LoyaltyLocationNotFound = 'LOYALTY_LOCATION_NOT_FOUND',
  LoyaltyNotProcessed = 'LOYALTY_NOT_PROCESSED',
  LoyaltyProgramUnavailable = 'LOYALTY_PROGRAM_UNAVAILABLE',
  MissingSku = 'MISSING_SKU',
  PriceMaximum = 'PRICE_MAXIMUM',
  PriceMinimum = 'PRICE_MINIMUM',
  RestaurantNotAcceptingOrders = 'RESTAURANT_NOT_ACCEPTING_ORDERS',
  RewardExpired = 'REWARD_EXPIRED',
  RewardNotApplicable = 'REWARD_NOT_APPLICABLE',
  RewardNotFound = 'REWARD_NOT_FOUND',
  TimeRestriction = 'TIME_RESTRICTION',
}

/** Reward Validation Metadata */
export type ValidateRewardFailureMetadata = {
  readonly __typename?: 'ValidateRewardFailureMetadata';
  readonly requiredChannel: Maybe<Scalars['String']['output']>;
  readonly requiredDays: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
};

export type ValidationError = {
  readonly __typename?: 'ValidationError';
  readonly fieldErrors: ReadonlyArray<FieldValidationError>;
  readonly message: Scalars['String']['output'];
  readonly status: Scalars['Int']['output'];
};

export type Vendor = {
  readonly __typename?: 'Vendor';
  readonly name: Scalars['String']['output'];
  readonly restaurantId: Scalars['String']['output'];
};
